import React from "react";
import PropTypes from "prop-types";

const IndividualsAndGroupsIllustration = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      fill={props.fill}
      style={props.style}
      viewBox="0 0 2000 2000"
    >
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1325.000000,2001.000000 
	C883.333313,2001.000000 442.166656,2001.000000 1.000000,2001.000000 
	C1.000000,1334.333374 1.000000,667.666687 1.000000,1.000000 
	C667.666687,1.000000 1334.333374,1.000000 2001.000000,1.000000 
	C2001.000000,667.666687 2001.000000,1334.333374 2001.000000,2001.000000 
	C1775.833374,2001.000000 1550.666626,2001.000000 1325.000000,2001.000000 
M449.537048,1124.817627 
	C449.235443,1125.063232 448.933807,1125.308960 448.632172,1125.554565 
	C448.743317,1125.628418 448.915741,1125.790161 448.956085,1125.762085 
	C449.307983,1125.517090 449.636292,1125.238281 450.524780,1125.047241 
	C450.843140,1124.868774 451.161499,1124.690186 452.155487,1124.294678 
	C477.586151,1111.348999 503.016785,1098.403442 528.775085,1085.291016 
	C527.765503,1083.099243 527.046082,1081.456543 526.261353,1079.845581 
	C506.534515,1039.350464 486.786987,998.865540 467.082123,958.359802 
	C463.831085,951.676941 463.468140,951.500427 456.626373,955.548279 
	C462.175476,966.807434 467.715668,978.115051 473.313904,989.393860 
	C486.027130,1015.007202 498.772736,1040.604614 511.496368,1066.212769 
	C514.484192,1072.226318 514.245300,1073.323364 508.981476,1077.523804 
	C504.818268,1080.845825 500.594727,1084.092163 496.428925,1087.411133 
	C481.213409,1099.533936 466.010986,1111.673096 450.213440,1124.020142 
	C450.164398,1124.363159 450.115356,1124.706055 449.537048,1124.817627 
M443.339813,1386.775879 
	C442.277466,1387.236938 441.172241,1387.619141 440.158813,1388.170166 
	C393.244354,1413.679810 346.337524,1439.203369 299.431030,1464.727539 
	C292.617157,1468.435425 285.809692,1472.155029 278.909851,1475.917969 
	C282.741364,1485.524292 286.270966,1494.666626 290.046448,1503.706055 
	C291.733398,1507.744995 290.811584,1510.205811 286.863129,1512.140015 
	C274.764069,1518.067139 262.714447,1524.101196 250.762375,1530.318359 
	C247.452209,1532.040039 244.770279,1531.998047 241.434418,1530.307617 
	C219.173874,1519.027466 196.766693,1508.036011 174.534561,1496.701050 
	C171.258560,1495.030884 168.214111,1492.412598 165.826172,1489.587524 
	C158.773071,1481.243408 152.102966,1472.575439 145.099380,1463.804077 
	C140.664444,1467.551758 136.654633,1470.940308 132.437195,1474.504150 
	C164.687042,1516.239380 196.635651,1557.584595 228.675217,1599.047729 
	C240.665817,1595.485229 252.451752,1592.007324 264.222137,1588.477539 
	C271.380859,1586.330688 279.312805,1585.412109 285.497009,1581.643555 
	C298.815033,1573.527588 311.228455,1563.927002 324.375641,1554.678345 
	C316.712738,1548.277466 309.471619,1542.189819 302.185883,1536.155884 
	C296.877045,1531.759155 296.783508,1529.699463 301.684113,1524.991943 
	C314.774536,1512.417847 327.851318,1499.829346 340.909668,1487.221802 
	C366.549683,1462.467285 392.201233,1437.724365 417.789001,1412.916016 
	C426.609192,1404.364502 435.253662,1395.631958 444.521515,1386.892456 
	C444.501434,1386.682983 444.481384,1386.473389 444.461334,1386.263916 
	C444.335663,1386.284302 444.108917,1386.286133 444.101074,1386.328369 
	C444.057617,1386.562744 444.067535,1386.807129 443.339813,1386.775879 
M642.123840,1178.141235 
	C662.049988,1155.973755 682.023499,1133.848389 701.842468,1111.585449 
	C704.321655,1108.800659 706.861694,1107.678955 710.512695,1107.973022 
	C724.279297,1109.081909 738.051453,1110.183105 751.841492,1110.903687 
	C756.189453,1111.130859 758.417664,1112.842285 759.874695,1116.800049 
	C764.525818,1129.433472 769.179749,1142.077881 774.359497,1154.498291 
	C776.320984,1159.201660 775.358826,1162.062988 771.917969,1165.416016 
	C741.137085,1195.410889 710.526367,1225.580200 679.745667,1255.575073 
	C677.005432,1258.245361 676.616821,1260.149414 678.545044,1263.554688 
	C687.234619,1278.900269 695.466675,1294.505127 704.158997,1309.849243 
	C707.261353,1315.325806 709.507996,1320.718750 709.316833,1327.194580 
	C709.150635,1332.828979 709.875000,1338.489624 710.210876,1344.138550 
	C712.473755,1382.184937 714.729004,1420.231934 717.008179,1458.277466 
	C717.541565,1467.181274 718.157593,1476.080078 718.768494,1485.487305 
	C782.558960,1483.346069 845.700256,1481.226685 908.828430,1479.107544 
	C908.886047,1478.046387 909.000732,1477.539429 908.927246,1477.061401 
	C903.142883,1439.413330 897.338318,1401.768188 891.547241,1364.121094 
	C885.680542,1325.982788 879.893127,1287.832153 873.929504,1249.708984 
	C871.871643,1236.553833 870.143372,1223.873535 861.537842,1212.123779 
	C827.500916,1165.651245 794.619324,1118.332397 761.324158,1071.316772 
	C759.972595,1069.408325 759.080505,1067.690186 755.876587,1068.450928 
	C735.331848,1073.329102 714.697876,1077.831787 694.157349,1082.726929 
	C692.126892,1083.210938 689.858704,1085.140869 688.834167,1087.018188 
	C679.988403,1103.226074 671.359680,1119.553345 662.752502,1135.890381 
	C655.395081,1149.855591 648.151367,1163.880615 640.331848,1178.202637 
	C640.230530,1178.704590 640.129211,1179.206665 639.816040,1180.758667 
	C640.861633,1179.422729 641.220520,1178.964233 642.123840,1178.141235 
M279.169159,1054.427002 
	C279.328613,1058.081543 279.521820,1061.734985 279.642212,1065.390747 
	C280.789795,1100.233765 285.024139,1134.702271 291.880402,1168.878174 
	C308.682495,1252.630737 341.012238,1329.930420 388.117035,1401.114624 
	C388.819641,1402.176270 389.721161,1403.106201 390.604492,1404.189209 
	C412.640991,1392.199829 434.384369,1380.307007 456.210602,1368.568115 
	C459.224091,1366.947510 462.971497,1366.584229 465.790192,1364.739136 
	C468.562134,1362.924927 471.652557,1360.330200 472.649719,1357.410645 
	C473.752625,1354.181396 472.777863,1350.182739 472.464478,1346.540161 
	C471.322113,1333.262817 471.254272,1320.329956 480.623444,1309.266968 
	C483.165436,1306.265381 484.464417,1302.237671 486.840668,1299.059937 
	C488.546021,1296.779297 490.845428,1294.684204 493.322906,1293.298218 
	C497.411316,1291.010864 501.857666,1289.363281 506.972748,1287.080200 
	C496.232086,1280.673218 486.401917,1274.807129 476.569672,1268.944580 
	C451.981201,1254.283203 427.385712,1239.633545 402.807587,1224.954956 
	C397.608643,1221.849731 397.232513,1219.229614 401.205322,1214.660767 
	C401.860199,1213.907715 402.593658,1213.223755 403.278473,1212.496094 
	C411.417542,1203.847046 419.554291,1195.195679 427.691681,1186.545044 
	C425.855194,1186.384155 424.471344,1186.819824 423.138245,1187.376831 
	C413.624329,1191.352173 404.125275,1195.363159 394.612274,1199.340576 
	C388.300110,1201.979858 387.464600,1201.683960 384.016632,1195.570801 
	C376.657837,1182.523560 369.306274,1169.472168 361.977905,1156.407837 
	C359.698914,1152.344971 356.768951,1148.464844 355.404205,1144.104492 
	C350.687164,1129.033691 346.511200,1113.793213 342.170502,1098.605591 
	C341.100037,1094.859985 342.227936,1092.225342 346.044067,1090.635376 
	C349.193207,1089.323242 352.131836,1087.505859 355.217407,1085.884155 
	C354.257812,1083.888794 353.575562,1082.373169 352.813110,1080.899048 
	C338.139618,1052.530029 323.453003,1024.167847 308.778778,995.799255 
	C305.617798,989.688354 305.842529,988.699585 311.225006,984.552734 
	C321.120361,976.929016 331.026306,969.318970 340.919922,961.692993 
	C367.303741,941.355957 393.676239,921.004333 420.070465,900.680847 
	C425.338562,896.624390 427.580139,897.110352 430.463654,902.867004 
	C434.934143,911.791870 439.350861,920.743652 443.795013,929.681763 
	C446.511566,935.145325 449.236694,940.604675 451.829620,945.808228 
	C452.640259,945.808228 452.812531,945.847351 452.958862,945.802246 
	C455.976196,944.873352 458.987183,943.923767 462.006165,943.000244 
	C468.600891,940.982971 469.616058,941.461914 472.525421,947.441223 
	C494.211670,992.010132 515.912659,1036.571899 537.626221,1081.127563 
	C541.386597,1088.843750 541.132568,1089.789795 533.421204,1093.721558 
	C508.227570,1106.567017 483.013092,1119.371582 457.821716,1132.221436 
	C450.927765,1135.737915 444.086578,1139.358032 436.893585,1143.101196 
	C442.142639,1149.144531 446.925537,1154.651123 452.037048,1160.536011 
	C455.362366,1156.546753 458.503998,1158.125854 461.879089,1160.158325 
	C502.664062,1184.718384 543.486023,1209.217163 584.303894,1233.722656 
	C585.980713,1234.729370 587.712402,1235.644775 589.605347,1236.707642 
	C602.283691,1222.612305 614.789612,1208.800781 627.097107,1194.814697 
	C627.902649,1193.899414 627.172974,1191.646973 627.185486,1190.016724 
	C627.205750,1187.364014 626.323059,1184.226074 627.421143,1182.131470 
	C645.574036,1147.505493 663.936523,1112.988525 682.432922,1078.544434 
	C683.459167,1076.633545 685.861267,1074.732300 687.956421,1074.236816 
	C711.095459,1068.765991 734.307373,1063.604492 757.480957,1058.278320 
	C761.316223,1057.396851 763.929138,1058.158203 766.379517,1061.630737 
	C803.053345,1113.603149 839.891296,1165.459717 876.564148,1217.432739 
	C878.301086,1219.894287 879.407227,1223.098999 879.885315,1226.104248 
	C884.536743,1255.345093 888.998169,1284.616211 893.500244,1313.880737 
	C899.343872,1351.865723 905.165344,1389.854126 911.016602,1427.838013 
	C913.381836,1443.192383 915.800598,1458.538452 918.194946,1473.888306 
	C918.735107,1473.857788 919.275208,1473.827271 919.815369,1473.796753 
	C919.815369,1459.481689 919.606873,1445.162964 919.858765,1430.852295 
	C920.380249,1401.219360 921.165833,1371.591309 921.808105,1341.960449 
	C922.825623,1295.019531 923.793091,1248.077637 924.823608,1201.136963 
	C925.444946,1172.838989 926.199341,1144.543823 926.797424,1116.245361 
	C927.620789,1077.290161 928.014404,1038.321289 929.379883,999.385803 
	C929.692322,990.477417 927.738586,985.437744 918.889343,983.229309 
	C916.958435,982.747437 914.482361,979.782715 914.279236,977.758606 
	C911.985657,954.907532 910.071106,932.018188 908.085938,909.136414 
	C905.956848,884.595459 903.885925,860.049377 901.743896,835.509521 
	C899.182312,806.163879 896.583069,776.821533 893.978699,747.479675 
	C892.642090,732.420471 891.258728,717.365540 889.861572,701.922791 
	C875.718750,704.160583 861.961975,706.343384 848.203125,708.512634 
	C830.130981,711.362061 812.048279,714.146423 793.991577,717.090454 
	C790.434265,717.670471 788.030273,716.631226 785.796692,713.836853 
	C782.056396,709.157410 777.830139,704.867065 774.074097,700.199280 
	C772.148499,697.806274 770.220093,697.337708 767.218201,697.761108 
	C742.834900,701.200317 718.411804,704.356628 694.024963,707.771973 
	C689.651062,708.384583 686.627747,707.363281 683.567932,703.948242 
	C644.337891,660.164185 604.901428,616.565002 565.700623,572.754944 
	C562.643982,569.338867 560.200867,568.695679 556.584290,571.069214 
	C551.998474,574.078796 548.190308,573.004700 544.031372,569.581909 
	C534.132385,561.435120 523.715576,553.917664 513.818054,545.769287 
	C510.319916,542.889404 508.104065,542.571899 504.745361,545.881958 
	C487.671570,562.708435 469.692841,578.671814 453.326019,596.150208 
	C399.164825,653.989807 357.343750,719.896973 327.356567,793.237366 
	C293.267090,876.610962 277.522614,963.432861 279.169159,1054.427002 
M1188.855957,1155.376221 
	C1183.704590,1271.624268 1178.553101,1387.872314 1173.401733,1504.120361 
	C1173.954224,1504.366699 1174.506592,1504.613159 1175.059082,1504.859497 
	C1173.541992,1497.025757 1178.918945,1495.452637 1183.919800,1493.387939 
	C1202.825439,1485.582764 1221.650879,1477.579956 1240.638306,1469.980591 
	C1243.252075,1468.934570 1246.918579,1468.883423 1249.569824,1469.837769 
	C1264.273560,1475.130737 1278.811523,1480.883423 1293.413696,1486.459473 
	C1295.221680,1487.149902 1297.073608,1487.726196 1299.131592,1488.432983 
	C1299.468750,1487.346680 1299.760254,1486.759644 1299.824951,1486.148560 
	C1302.542236,1460.492798 1305.254272,1434.836548 1307.935059,1409.177002 
	C1311.446045,1375.571045 1314.883789,1341.957275 1318.512817,1308.364136 
	C1318.809937,1305.612915 1318.359009,1304.200562 1315.877075,1302.824707 
	C1307.729492,1298.308228 1299.861328,1293.280273 1291.650269,1288.888916 
	C1287.110718,1286.461182 1286.185669,1283.430908 1287.409302,1278.693726 
	C1291.110107,1264.366943 1294.531616,1249.967773 1298.048462,1235.593506 
	C1305.793213,1203.937622 1313.539673,1172.282104 1321.255127,1140.619019 
	C1322.092773,1137.181396 1323.294556,1134.611938 1327.490723,1134.012573 
	C1369.980347,1127.942139 1412.447754,1121.716431 1454.922119,1115.538574 
	C1459.559448,1114.864014 1461.742310,1116.657715 1461.854858,1121.505737 
	C1462.238159,1137.986938 1462.685547,1154.468750 1462.837280,1170.952881 
	C1463.005371,1189.221802 1462.875610,1207.493530 1462.875610,1225.764038 
	C1463.466187,1225.818604 1464.056763,1225.873169 1464.647339,1225.927734 
	C1465.108032,1224.598633 1465.581909,1223.273926 1466.027466,1221.939819 
	C1476.660522,1190.096191 1487.360229,1158.274536 1497.837158,1126.379517 
	C1499.223877,1122.157959 1501.184326,1120.547974 1505.715942,1120.907959 
	C1527.948364,1122.674438 1550.200928,1124.191406 1572.450928,1125.730713 
	C1575.376953,1125.933105 1578.329102,1125.758423 1581.201904,1125.758423 
	C1587.281372,1099.685913 1589.262939,1009.104553 1584.288940,982.756653 
	C1583.821533,984.403870 1583.373779,985.639526 1583.123779,986.914001 
	C1579.378418,1006.006775 1575.671265,1025.107178 1571.929932,1044.200806 
	C1568.188721,1063.294434 1564.435913,1082.386108 1560.643677,1101.469727 
	C1560.068359,1104.364624 1559.832397,1107.509766 1555.843262,1108.140259 
	C1541.552368,1110.399170 1527.294312,1112.874390 1512.978027,1114.952881 
	C1510.996582,1115.240723 1508.286987,1114.325806 1506.709839,1113.012573 
	C1484.694336,1094.680054 1462.784058,1076.220093 1440.975830,1057.641235 
	C1439.412109,1056.309082 1438.116455,1053.880615 1437.924805,1051.845947 
	C1436.676514,1038.591797 1435.784180,1025.304199 1434.744873,1012.030029 
	C1432.211426,979.676025 1429.714233,947.318970 1427.055420,914.975220 
	C1426.695801,910.600281 1428.294312,908.373535 1432.233643,906.589417 
	C1459.503662,894.238953 1486.697632,881.719360 1513.858398,869.129822 
	C1517.474365,867.453735 1520.291626,867.760559 1523.496338,870.131592 
	C1537.151855,880.234558 1550.946899,890.149109 1564.703369,900.115417 
	C1567.290771,901.989929 1569.933838,903.787292 1573.719116,906.438049 
	C1542.883179,766.841919 1475.806030,649.761902 1371.049805,554.667725 
	C1290.850342,481.865479 1197.887451,432.450012 1092.655151,405.467560 
	C1092.354858,407.145416 1092.081421,408.098511 1092.026855,409.063965 
	C1090.968628,427.839447 1089.929321,446.615997 1088.901611,465.393219 
	C1088.553467,471.754791 1087.483398,472.849823 1081.204712,473.135315 
	C1075.466919,473.396240 1069.729370,473.663483 1063.664673,473.942993 
	C1066.620605,499.468506 1069.491333,524.257202 1072.487061,550.126282 
	C1074.411377,542.712830 1076.116821,536.215393 1077.782104,529.707703 
	C1079.588379,522.648743 1080.630615,522.048950 1087.882324,523.361938 
	C1107.680298,526.946411 1127.487793,530.479675 1147.297974,533.996338 
	C1179.886841,539.781433 1212.497437,545.447510 1245.044067,551.461121 
	C1247.929810,551.994385 1251.140747,554.147583 1252.966553,556.504395 
	C1267.961182,575.860229 1282.664795,595.441467 1297.453857,614.956604 
	C1315.460571,638.717468 1333.465210,662.479919 1351.468750,686.243225 
	C1355.513062,691.581299 1355.257202,693.320007 1349.891357,697.168091 
	C1347.938965,698.568298 1345.991455,699.975159 1343.898071,701.482422 
	C1358.309570,718.873840 1372.296265,735.832397 1386.403076,752.690308 
	C1388.516479,755.216003 1389.194458,757.520569 1388.438354,760.854431 
	C1377.625732,808.533203 1366.911011,856.234497 1356.345215,903.968567 
	C1355.328369,908.562866 1354.479004,913.573059 1355.223999,918.116028 
	C1359.610352,944.867249 1364.392822,971.555542 1369.313965,998.214844 
	C1370.058228,1002.246460 1369.035156,1004.480347 1365.641357,1006.338989 
	C1348.710205,1015.610779 1331.866577,1025.042969 1314.875122,1034.201782 
	C1313.097534,1035.159912 1309.781616,1035.636963 1308.557373,1034.641846 
	C1307.060303,1033.425293 1306.380615,1030.393433 1306.468872,1028.191406 
	C1306.713135,1022.094727 1307.539917,1016.021423 1308.136475,1009.938843 
	C1305.845459,1014.276245 1304.140381,1018.738403 1303.006226,1023.341187 
	C1301.812866,1028.184448 1299.185303,1030.007935 1294.322510,1028.937256 
	C1288.480957,1027.651001 1282.622681,1026.424316 1276.739502,1025.347412 
	C1272.385254,1024.550537 1271.023071,1022.230225 1271.729492,1017.900146 
	C1274.461060,1001.154297 1277.002563,984.377441 1279.601807,967.610107 
	C1280.758057,960.151550 1281.883301,952.688232 1283.142456,944.443176 
	C1275.662720,947.892761 1269.022949,950.906494 1262.427612,954.014709 
	C1258.363037,955.930237 1255.616089,955.138306 1253.578247,950.862305 
	C1249.643188,942.605164 1245.343018,934.522766 1241.251709,926.339233 
	C1238.282349,920.399780 1238.969482,918.628540 1245.105469,916.097717 
	C1258.326050,910.644958 1271.597534,905.311035 1284.728760,899.651428 
	C1286.480225,898.896606 1288.465332,896.694275 1288.780640,894.889526 
	C1295.391357,857.039795 1301.789062,819.152832 1308.164429,781.262390 
	C1308.421509,779.734436 1308.627686,777.725952 1307.880981,776.574341 
	C1300.567261,765.292175 1293.046143,754.144470 1285.416992,742.708374 
	C1282.940308,744.445618 1280.770874,745.955383 1278.613770,747.482544 
	C1271.764038,752.331848 1271.180420,752.301758 1265.209595,746.429810 
	C1255.705444,737.083069 1246.244263,727.692383 1236.716553,718.369629 
	C1229.775391,711.577759 1222.756348,704.865540 1214.877563,697.253723 
	C1214.877563,700.503418 1214.893921,702.452637 1214.875000,704.401489 
	C1214.647827,727.717102 1214.378906,751.032471 1214.192261,774.348450 
	C1213.832153,819.328064 1213.493164,864.307800 1213.194458,909.287842 
	C1213.035156,933.283203 1213.008301,957.279419 1212.865234,981.274902 
	C1212.768799,997.456970 1214.849487,995.016724 1198.972168,999.296570 
	C1198.811768,999.339783 1198.659912,999.435303 1198.498535,999.451904 
	C1195.000854,999.812378 1194.115234,1001.728760 1194.064331,1005.182312 
	C1193.801392,1022.995911 1193.382935,1040.810669 1192.727783,1058.614380 
	C1191.552246,1090.548828 1190.169067,1122.475830 1188.855957,1155.376221 
M1108.644897,536.886963 
	C1101.475342,535.599304 1094.305786,534.311707 1087.035645,533.006042 
	C1086.612061,534.281860 1086.241089,535.195557 1086.003906,536.142700 
	C1074.619873,581.623474 1063.260864,627.110535 1051.841675,672.582458 
	C1051.101929,675.528381 1051.031982,679.297791 1046.906616,679.823486 
	C1042.522827,680.381958 1041.541870,676.629822 1040.070557,673.729309 
	C1023.742737,641.539551 1007.446655,609.333801 991.128479,577.139221 
	C985.730957,566.490356 980.294678,555.861267 974.887146,545.244812 
	C973.327271,545.586670 972.195740,545.790771 971.087708,546.083801 
	C934.282959,555.816528 897.477539,565.546265 860.678711,575.301147 
	C828.540344,583.820740 796.403137,592.345032 764.295044,600.977356 
	C762.638428,601.422668 760.229004,602.676941 759.950745,603.945251 
	C759.196960,607.380920 759.403137,611.027283 759.207581,615.016907 
	C766.175842,613.345154 772.467957,611.838806 778.758484,610.325439 
	C782.564758,609.409851 785.222412,610.273315 786.272888,614.533630 
	C792.163574,638.424438 798.142578,662.293518 804.080811,686.172668 
	C805.136719,690.418335 803.665771,692.920166 799.130005,693.470032 
	C794.071777,694.083252 789.032410,694.851807 783.034790,695.684692 
	C785.815308,698.974426 788.222900,701.438660 790.163513,704.227844 
	C792.076416,706.977112 794.361633,707.469299 797.461426,706.956177 
	C812.886292,704.402710 828.334229,701.988281 843.773315,699.520752 
	C859.211487,697.053467 874.639832,694.522705 890.090515,692.137146 
	C897.350220,691.016174 898.470215,691.940735 899.187256,699.289734 
	C900.463806,712.373535 901.705322,725.461426 902.844055,738.557800 
	C905.986816,774.701477 909.038086,810.853088 912.182922,846.996582 
	C915.774841,888.278320 919.470520,929.551147 922.972717,970.840454 
	C923.240234,973.993713 924.457764,975.488892 927.235352,976.657104 
	C967.851074,993.739136 1008.419983,1010.932617 1049.050537,1027.979248 
	C1050.869385,1028.742310 1053.324707,1028.938721 1055.221191,1028.426880 
	C1103.210571,1015.475220 1151.157227,1002.365234 1199.143921,989.402771 
	C1202.030640,988.623047 1203.202637,987.631287 1203.209839,984.434448 
	C1203.243164,969.786743 1203.689819,955.140503 1203.795410,940.492371 
	C1204.177124,887.521118 1204.487305,834.549500 1204.812256,781.577881 
	C1205.002319,750.590210 1205.098999,719.601501 1205.483521,688.616272 
	C1205.513672,686.193848 1206.906616,682.900391 1208.758545,681.707214 
	C1209.951782,680.938354 1213.683472,682.703186 1215.352539,684.299622 
	C1229.917358,698.231140 1244.269287,712.385132 1258.693359,726.463867 
	C1263.285156,730.945740 1267.904175,735.399902 1272.585815,739.939453 
	C1296.083252,723.348694 1319.174561,707.044556 1342.458862,690.604309 
	C1341.244385,688.883728 1340.333008,687.508850 1339.338989,686.196655 
	C1308.667725,645.709290 1277.955566,605.252747 1247.382446,564.691345 
	C1245.285645,561.909485 1242.931641,560.619751 1239.673462,560.045837 
	C1196.275635,552.401611 1152.889526,544.690308 1108.644897,536.886963 
M1054.652710,1378.506104 
	C1055.398071,1444.416748 1056.143433,1510.327271 1056.892700,1576.588013 
	C1063.252808,1577.015869 1069.188721,1577.436768 1075.127808,1577.808960 
	C1082.258423,1578.255737 1083.644409,1580.279541 1081.189697,1586.974243 
	C1076.325073,1600.241211 1071.707153,1613.610352 1066.400391,1626.699097 
	C1063.295044,1634.357788 1064.541504,1641.968872 1064.241821,1649.874023 
	C1099.366699,1649.874023 1133.940918,1649.874023 1169.000000,1649.874023 
	C1169.000000,1646.843750 1168.712280,1644.018555 1169.056274,1641.272583 
	C1169.932739,1634.277466 1167.580078,1628.448608 1163.866211,1622.637085 
	C1155.532471,1609.596558 1147.606323,1596.294434 1139.587036,1583.054688 
	C1136.521606,1577.993530 1138.128052,1574.853027 1144.008545,1574.098877 
	C1149.573364,1573.385010 1155.143433,1572.712402 1161.028564,1571.982300 
	C1169.196655,1382.440063 1177.347656,1193.295776 1185.534180,1003.325989 
	C1182.606567,1003.999329 1181.017822,1004.308716 1179.459717,1004.731262 
	C1138.386719,1015.868286 1097.333252,1027.078857 1056.211426,1038.032593 
	C1053.284546,1038.812378 1049.521973,1038.538574 1046.718872,1037.376953 
	C1018.301453,1025.602295 990.004761,1013.536438 961.669617,1001.562988 
	C954.248230,998.426880 946.810913,995.328674 938.188110,991.712952 
	C938.188110,1001.098022 938.332092,1009.407593 938.164307,1017.710754 
	C937.212280,1064.818115 936.208130,1111.924561 935.176086,1159.030151 
	C934.556152,1187.325073 933.819702,1215.617432 933.195129,1243.912109 
	C932.166260,1290.517212 931.186523,1337.123291 930.184570,1383.729004 
	C929.504578,1415.354980 928.834717,1446.981079 928.137268,1478.606689 
	C927.439880,1510.230713 926.807861,1541.856934 925.885925,1573.474487 
	C925.764709,1577.630005 927.256104,1579.273193 930.854187,1580.545776 
	C937.119080,1582.761475 943.261841,1585.345581 949.368347,1587.977905 
	C953.709351,1589.849243 954.556091,1593.918579 950.880188,1596.476685 
	C942.424927,1602.361084 934.080444,1608.618164 924.949646,1613.268799 
	C910.742737,1620.505127 895.871155,1626.428101 881.419800,1633.203247 
	C879.613342,1634.050049 877.886780,1636.532349 877.461548,1638.540283 
	C876.690186,1642.182739 876.925964,1646.038330 876.716553,1650.311157 
	C923.477051,1650.895142 969.667542,1651.472168 1016.220276,1652.053589 
	C1015.956726,1649.219849 1015.772705,1647.080811 1015.556702,1644.945068 
	C1013.664734,1626.233521 1011.842041,1607.514526 1009.819519,1588.817017 
	C1009.300232,1584.015747 1011.044678,1581.659302 1015.807495,1581.012695 
	C1019.851868,1580.463501 1023.834961,1579.463013 1028.802002,1578.471069 
	C1028.802002,1569.535889 1028.587280,1561.058472 1028.838379,1552.594727 
	C1030.096924,1510.170288 1031.464111,1467.749023 1032.819580,1425.327393 
	C1033.792480,1394.883911 1034.825806,1364.442261 1035.798462,1333.998779 
	C1037.153809,1291.577515 1038.485840,1249.155273 1039.811890,1206.733032 
	C1040.592041,1181.775269 1041.372681,1156.817261 1042.067139,1131.857056 
	C1042.166870,1128.270142 1043.061646,1125.153687 1047.097534,1125.311035 
	C1051.044922,1125.465210 1051.867676,1128.678467 1051.902466,1132.205078 
	C1052.106689,1152.853638 1052.403442,1173.501465 1052.650269,1194.149658 
	C1052.992676,1222.794189 1053.335938,1251.438599 1053.647339,1280.083496 
	C1054.000610,1312.558350 1054.318970,1345.033569 1054.652710,1378.506104 
M1324.741333,1167.208984 
	C1315.462891,1204.956909 1306.184326,1242.704956 1296.865479,1280.616943 
	C1306.326172,1286.159424 1315.615967,1291.349609 1324.580078,1297.051514 
	C1326.536377,1298.296021 1328.635010,1301.482666 1328.453613,1303.583740 
	C1326.821777,1322.481323 1324.714966,1341.338135 1322.710205,1360.203003 
	C1318.190552,1402.734375 1313.680542,1445.266602 1309.056885,1487.786621 
	C1308.691650,1491.145996 1309.524170,1492.758789 1312.835205,1494.012451 
	C1347.817993,1507.258545 1382.712402,1520.737793 1417.709717,1533.944946 
	C1420.073242,1534.837036 1423.362183,1534.826660 1425.727905,1533.932251 
	C1466.008423,1518.703613 1506.194336,1503.224731 1546.460571,1487.958130 
	C1549.875610,1486.663208 1551.289062,1484.740723 1551.952515,1481.281616 
	C1565.610352,1410.074707 1579.369995,1338.887085 1593.104370,1267.694946 
	C1593.674683,1264.738159 1594.622559,1262.166992 1598.266113,1262.008789 
	C1601.833496,1261.854004 1602.520020,1264.353760 1603.222656,1267.096436 
	C1608.089844,1286.099121 1613.031494,1305.082886 1617.946777,1324.073364 
	C1620.687378,1334.661255 1623.422729,1345.250488 1626.184570,1355.932129 
	C1652.259277,1349.398682 1677.821899,1342.993408 1703.533569,1336.550903 
	C1703.147461,1334.425537 1702.954346,1332.948486 1702.606934,1331.508545 
	C1691.100952,1283.832886 1679.600708,1236.156006 1667.987305,1188.506470 
	C1667.513672,1186.563110 1666.313110,1184.489868 1664.841309,1183.144165 
	C1649.355835,1168.984619 1633.811523,1154.886963 1618.085571,1140.996216 
	C1616.181763,1139.314575 1613.170532,1138.321289 1610.574707,1138.085205 
	C1598.975586,1137.030273 1587.339722,1136.382202 1575.719360,1135.556274 
	C1553.973267,1134.010376 1532.224365,1132.500122 1510.488525,1130.820190 
	C1507.433716,1130.584106 1506.053345,1131.482666 1505.169189,1134.401367 
	C1502.954102,1141.713745 1500.431274,1148.932983 1498.012451,1156.183105 
	C1487.075073,1188.965088 1476.114624,1221.739380 1465.215820,1254.534058 
	C1464.184082,1257.638306 1463.391602,1261.008301 1459.187988,1260.449463 
	C1454.573364,1259.835938 1455.046387,1256.087891 1454.975098,1252.707031 
	C1454.844971,1246.553467 1454.475952,1240.404785 1454.365112,1234.251221 
	C1453.879028,1207.278320 1453.412476,1180.304810 1453.020752,1153.330566 
	C1452.889038,1144.255005 1453.000000,1135.175903 1453.000000,1126.017212 
	C1450.742920,1126.017212 1449.908081,1125.914917 1449.105103,1126.031982 
	C1410.424194,1131.668335 1371.741821,1137.295410 1333.086792,1143.104614 
	C1331.857666,1143.289307 1330.329224,1145.197998 1329.934326,1146.585815 
	C1328.070801,1153.136963 1326.553955,1159.786499 1324.741333,1167.208984 
M627.643188,1376.865723 
	C616.474487,1366.375244 605.423584,1355.755371 594.096619,1345.438599 
	C586.245483,1338.287842 578.080872,1331.473633 569.883301,1324.719116 
	C568.600830,1323.662476 566.396118,1323.725220 564.617920,1323.270264 
	C568.351074,1331.722168 572.454712,1338.951050 576.812805,1346.023071 
	C579.169312,1349.847168 578.682617,1352.745361 575.236877,1355.577271 
	C571.378845,1358.748169 567.791077,1362.245239 564.013184,1365.516602 
	C560.163635,1368.849976 558.178955,1368.648560 554.923706,1364.560791 
	C551.434631,1360.179321 548.058594,1355.707642 543.835388,1350.243042 
	C544.185974,1352.717896 544.289368,1353.841553 544.509521,1354.941772 
	C547.285156,1368.811768 550.112061,1382.671387 552.849915,1396.548706 
	C554.089172,1402.829712 553.213257,1404.191162 547.167114,1405.886597 
	C542.843506,1407.098877 538.469116,1408.137695 534.172974,1409.437622 
	C530.191650,1410.642456 527.750977,1409.434326 526.585144,1405.405273 
	C525.105835,1400.292847 523.523193,1395.209717 521.943237,1390.127075 
	C520.819397,1386.511597 519.626404,1382.917847 518.464233,1379.314331 
	C516.960938,1387.476440 516.462830,1395.388672 516.011108,1403.303467 
	C515.636292,1409.871826 512.716309,1411.500366 506.934052,1408.226685 
	C497.374023,1402.813965 487.917603,1397.213013 478.266907,1391.968628 
	C474.712921,1390.037231 473.222595,1387.445679 473.332184,1383.575073 
	C473.421967,1380.404785 473.350433,1377.229736 473.350433,1372.672119 
	C418.145020,1425.974609 364.277252,1477.985718 310.153931,1530.243408 
	C321.564392,1539.762939 332.453217,1548.803223 343.290405,1557.904907 
	C349.999908,1563.539917 349.483154,1566.213257 341.705963,1569.851685 
	C311.799774,1583.843018 280.706635,1594.447266 248.879990,1603.081299 
	C236.250854,1606.507446 223.778381,1610.511108 211.160431,1614.273926 
	C211.805939,1621.022583 212.677948,1627.289795 212.913528,1633.580933 
	C213.076767,1637.940308 214.366562,1639.476685 219.059967,1639.461792 
	C275.059357,1639.284302 331.059570,1639.347412 387.059540,1639.347412 
	C388.676697,1639.347412 390.293854,1639.347412 392.089172,1639.347412 
	C392.449799,1636.789185 392.778992,1634.830811 392.995422,1632.859985 
	C394.757904,1616.810791 396.439331,1600.752319 398.282318,1584.712402 
	C398.862793,1579.660400 401.826813,1578.105103 406.339386,1580.249512 
	C410.094788,1582.033936 413.890991,1583.783813 417.450592,1585.914062 
	C420.790192,1587.912598 422.844543,1587.726685 425.754913,1584.581055 
	C464.886932,1542.284912 504.212708,1500.168213 543.498047,1458.013916 
	C548.366150,1452.790405 550.579285,1452.933838 554.836548,1458.693115 
	C566.222351,1474.095459 577.598328,1489.505371 588.981384,1504.909790 
	C618.181702,1544.425903 647.404419,1583.925415 676.538208,1623.490601 
	C678.474609,1626.120483 680.394775,1627.531982 683.877197,1627.445435 
	C690.856750,1627.271729 697.849487,1627.727051 704.838074,1627.802490 
	C738.150330,1628.162231 771.462708,1628.538330 804.775879,1628.792358 
	C822.080872,1628.924316 839.387695,1628.815552 857.279480,1628.815552 
	C864.859314,1582.726685 872.453491,1536.550415 880.128052,1489.885620 
	C877.426086,1489.885620 875.287109,1489.820801 873.153076,1489.895874 
	C857.018433,1490.463379 840.886597,1491.113892 824.750488,1491.633545 
	C788.640930,1492.796753 752.529785,1493.908936 716.418457,1495.015991 
	C710.825012,1495.187378 709.478638,1493.858887 709.131775,1488.102173 
	C708.461182,1476.973145 707.903320,1465.835693 707.048279,1454.720947 
	C706.900818,1452.804565 705.993591,1450.478394 704.632935,1449.192993 
	C679.209595,1425.173950 653.664490,1401.283813 627.643188,1376.865723 
M1055.315308,618.810059 
	C1060.950439,596.394226 1066.585693,573.978333 1072.319824,551.169128 
	C1062.728638,555.374939 1053.970581,559.412170 1045.031738,562.998718 
	C1042.755615,563.912048 1039.796631,563.937439 1037.337158,563.444275 
	C1024.131714,560.796387 1011.019226,557.679504 997.799805,555.109558 
	C992.997864,554.176086 991.402344,551.928467 991.861938,547.235229 
	C993.256775,532.992310 994.455444,518.729980 995.699524,504.472443 
	C996.517761,495.095490 997.282349,485.713806 998.039001,476.713959 
	C987.723633,476.713959 977.940430,476.560822 968.165710,476.783752 
	C963.804138,476.883240 961.680115,475.126434 961.095825,470.932373 
	C958.732056,453.963440 956.340820,436.998199 953.897095,420.040619 
	C952.269409,408.746185 950.535767,397.467010 948.868713,386.309662 
	C929.696228,384.612549 877.844788,387.224670 848.722778,391.142792 
	C792.059265,398.766388 737.202637,413.119415 684.342651,434.990387 
	C653.851624,447.606140 624.485474,462.440125 596.203003,479.436676 
	C593.761780,480.903717 591.968994,482.116455 592.958496,485.602478 
	C595.313965,493.900696 597.259521,502.315247 599.047668,509.402588 
	C602.573364,511.562378 605.418396,512.827881 607.688293,514.766846 
	C645.931213,547.433228 684.338379,579.915588 722.091858,613.140137 
	C729.688354,619.825378 736.390686,622.282410 745.458313,618.290222 
	C745.756714,618.158936 746.234131,618.257996 746.412048,618.057678 
	C747.577454,616.745911 749.467407,615.483337 749.658875,614.014099 
	C750.194092,609.908081 750.247253,605.699341 750.064392,601.549927 
	C749.845642,596.585693 751.741516,594.167542 756.764099,592.847961 
	C829.119629,573.838135 901.428650,554.651062 973.726257,535.421692 
	C978.195190,534.232971 980.806763,535.330750 982.926575,539.556763 
	C997.768250,569.144653 1012.786926,598.643738 1027.761841,628.164795 
	C1033.241089,638.966431 1038.754883,649.750488 1044.716675,661.452942 
	C1048.342651,646.877136 1051.733765,633.245239 1055.315308,618.810059 
M1785.919434,1629.468018 
	C1832.085815,1601.951782 1853.429321,1549.554810 1838.818481,1498.425903 
	C1824.639038,1448.806641 1777.902710,1413.796021 1724.338135,1415.528198 
	C1677.913696,1417.029297 1638.754639,1448.970337 1626.469849,1479.670898 
	C1638.736694,1484.785034 1650.980591,1489.963013 1663.293335,1494.971802 
	C1666.405518,1496.237915 1668.000854,1498.065918 1668.390747,1501.527344 
	C1669.769165,1513.758545 1671.222900,1525.989136 1673.066895,1538.156372 
	C1673.820801,1543.131592 1672.657837,1547.194580 1670.130493,1551.344116 
	C1665.718872,1558.587646 1661.469238,1565.943848 1657.541748,1573.456665 
	C1656.695801,1575.074829 1656.752441,1577.996460 1657.671875,1579.570801 
	C1663.713257,1589.914795 1670.150757,1600.026489 1676.369141,1610.268433 
	C1681.988159,1619.523438 1682.622559,1617.855103 1675.640381,1627.039551 
	C1674.849854,1628.079468 1674.227173,1629.246948 1673.250488,1630.792480 
	C1711.024780,1649.785767 1748.213135,1649.879028 1785.919434,1629.468018 
M703.253662,1652.201904 
	C771.083069,1677.911133 841.334839,1691.543945 913.764160,1693.753784 
	C974.674988,1695.612305 1034.752075,1689.078979 1093.810425,1673.916260 
	C1109.010498,1670.013916 1124.029541,1665.406860 1139.131714,1661.123535 
	C1139.054077,1660.706665 1138.976440,1660.289917 1138.898804,1659.873047 
	C1137.316040,1659.873047 1135.733398,1659.873047 1134.150757,1659.873047 
	C1111.654907,1659.873047 1089.158936,1659.873047 1066.663086,1659.873047 
	C1055.002197,1659.873047 1055.494629,1659.846802 1054.866211,1648.051758 
	C1054.213379,1635.797363 1056.369507,1624.360107 1061.173096,1613.144165 
	C1064.762573,1604.763306 1067.610474,1596.064941 1070.891357,1587.231201 
	C1066.546509,1586.873901 1062.603271,1586.323120 1058.652832,1586.266357 
	C1045.795044,1586.081787 1047.505615,1585.052002 1047.250000,1574.144775 
	C1046.559082,1544.675537 1046.441162,1515.192749 1046.132080,1485.714844 
	C1045.776001,1451.737793 1045.444702,1417.760742 1045.134766,1383.783325 
	C1045.063721,1375.996338 1045.124390,1368.208130 1045.124390,1360.420410 
	C1043.384399,1389.535400 1042.421753,1418.644775 1041.478271,1447.754761 
	C1040.038452,1492.174927 1038.567505,1536.594238 1037.253052,1581.018188 
	C1037.130737,1585.153564 1035.432129,1587.117310 1031.588501,1587.809326 
	C1027.708984,1588.507568 1023.854675,1589.345215 1019.711365,1590.177612 
	C1020.003845,1593.737793 1020.207764,1596.872192 1020.526672,1599.995117 
	C1022.335938,1617.712769 1024.265015,1635.418701 1025.957031,1653.147461 
	C1026.686279,1660.788452 1025.855835,1661.534424 1018.156128,1661.461182 
	C986.179016,1661.156982 954.202271,1660.815308 922.225647,1660.467163 
	C906.070496,1660.291260 889.915833,1660.071899 873.760925,1659.873413 
	C867.700256,1659.798950 866.461487,1658.508301 866.833435,1652.399170 
	C867.207703,1646.251709 867.830444,1640.115601 868.048584,1633.963989 
	C868.188904,1630.005249 869.688782,1627.639160 873.473572,1625.998291 
	C889.036316,1619.250488 904.579956,1612.436768 919.899109,1605.160034 
	C926.080017,1602.224243 931.666931,1598.038208 938.411255,1593.873291 
	C931.695557,1591.181763 926.359985,1588.938232 920.943665,1586.910522 
	C917.479065,1585.613281 916.290222,1583.520996 916.406006,1579.700195 
	C917.096802,1556.902100 917.543396,1534.096313 917.978210,1511.291138 
	C918.125916,1503.544067 918.001709,1495.791870 918.001709,1488.763550 
	C908.667664,1488.763550 899.545654,1488.763550 890.042236,1488.763550 
	C888.279663,1499.417236 886.624084,1509.396729 884.978149,1519.377686 
	C878.753113,1557.125000 872.458679,1594.861206 866.393311,1632.634155 
	C865.569031,1637.767212 863.091492,1639.155151 858.289124,1639.029541 
	C841.646606,1638.594482 824.997375,1638.378052 808.349426,1638.193481 
	C765.876404,1637.722534 723.403137,1637.234131 680.928650,1636.991943 
	C676.213867,1636.965088 673.311096,1635.431396 670.588379,1631.701782 
	C653.797913,1608.701538 636.191772,1586.271240 620.064636,1562.820801 
	C607.205505,1544.122437 592.082703,1528.537598 572.584656,1516.737427 
	C557.809814,1507.795776 543.971252,1497.307007 529.378906,1487.274780 
	C517.700439,1499.820923 506.207520,1512.167725 494.537506,1524.704834 
	C556.309448,1580.334106 625.402527,1622.699463 703.253662,1652.201904 
M1478.018311,1567.478394 
	C1457.055542,1559.444214 1436.093262,1551.409180 1415.130005,1543.376343 
	C1360.004395,1522.253174 1304.888062,1501.105591 1249.717651,1480.100220 
	C1247.457031,1479.239502 1244.338013,1478.852539 1242.208008,1479.709351 
	C1223.848999,1487.094849 1205.602051,1494.762329 1187.406128,1502.543335 
	C1185.950928,1503.165649 1184.364014,1505.147339 1184.131958,1506.691772 
	C1182.599731,1516.892578 1181.170410,1527.124878 1180.276489,1537.396362 
	C1179.995972,1540.618530 1180.793335,1544.334961 1182.265381,1547.231567 
	C1186.183228,1554.940552 1191.124756,1562.137207 1194.910889,1569.902588 
	C1197.747314,1575.720337 1201.806519,1578.089844 1208.063843,1579.339722 
	C1301.519531,1598.006348 1394.920288,1616.947754 1488.336914,1635.810669 
	C1497.421143,1637.645020 1506.523682,1639.388306 1515.990234,1641.247070 
	C1520.719604,1623.146606 1525.332397,1605.492065 1530.052979,1587.425049 
	C1512.833618,1580.839111 1495.781494,1574.317139 1478.018311,1567.478394 
M413.411316,1215.817383 
	C412.683319,1216.699585 411.955292,1217.581909 411.137787,1218.572510 
	C412.117096,1219.208984 412.932220,1219.778198 413.783752,1220.286377 
	C436.791748,1234.015015 459.696747,1247.920898 482.849823,1261.400635 
	C500.197510,1271.500366 516.458069,1283.717163 535.990845,1289.704224 
	C542.062195,1291.565186 547.517090,1293.991699 550.026489,1300.460083 
	C550.361450,1301.323608 551.186890,1302.160400 552.001343,1302.649902 
	C565.662964,1310.862915 579.359009,1319.018555 595.277588,1328.517700 
	C607.173767,1315.740967 618.879517,1302.491943 631.314331,1289.966797 
	C651.733337,1269.399780 672.631348,1249.308594 693.316101,1229.005127 
	C716.498840,1206.249756 739.699341,1183.512207 762.754456,1160.628418 
	C763.901855,1159.489502 764.582764,1156.729492 764.050232,1155.233643 
	C760.260986,1144.589233 756.219666,1134.027954 751.921509,1123.578857 
	C751.298767,1122.064941 748.950745,1120.461426 747.273438,1120.309692 
	C736.005066,1119.290283 724.709045,1118.473633 713.404785,1118.043579 
	C711.183105,1117.958862 708.223938,1119.246094 706.721252,1120.909180 
	C669.770813,1161.805542 632.964783,1202.832153 596.153076,1243.853638 
	C591.755859,1248.753784 590.966614,1248.934937 585.231079,1245.489746 
	C562.971985,1232.119019 540.720581,1218.735474 518.456909,1205.372437 
	C498.629150,1193.471313 478.788910,1181.590942 459.585205,1170.079712 
	C455.781372,1172.873901 451.997650,1174.921631 449.149841,1177.872681 
	C437.245453,1190.208374 425.622040,1202.815308 413.411316,1215.817383 
M1471.629150,899.093750 
	C1461.350464,903.808350 1451.122192,908.638306 1440.762329,913.167114 
	C1437.658813,914.523804 1436.640381,916.248962 1436.963745,919.590332 
	C1437.893677,929.197327 1438.499268,938.835449 1439.251221,948.459900 
	C1441.804688,981.149109 1444.317505,1013.841858 1447.035278,1046.517456 
	C1447.215088,1048.679321 1448.460327,1051.317383 1450.086914,1052.708130 
	C1469.838013,1069.594971 1489.702515,1086.351196 1509.716797,1102.924927 
	C1511.462402,1104.370483 1514.579102,1105.081543 1516.879395,1104.777222 
	C1527.096069,1103.425415 1537.238647,1101.522705 1547.427856,1099.947632 
	C1550.278809,1099.506958 1551.545654,1098.330200 1552.138550,1095.291138 
	C1562.868408,1040.285645 1573.725586,985.304749 1584.676147,930.342773 
	C1585.243530,927.495117 1584.301636,926.156067 1582.184082,924.630859 
	C1561.644043,909.837341 1541.139404,894.994019 1520.722290,880.031616 
	C1518.513794,878.413269 1516.925903,878.325623 1514.498657,879.466248 
	C1500.500977,886.044495 1486.408936,892.421997 1471.629150,899.093750 
M390.885468,1133.640625 
	C393.841736,1139.352539 396.797974,1145.064453 399.879883,1151.019043 
	C401.310181,1149.986084 402.254913,1149.354126 403.145538,1148.653442 
	C435.201141,1123.431641 467.220978,1098.164185 499.355103,1073.042725 
	C502.260620,1070.771362 502.185120,1069.006226 500.690308,1066.000244 
	C475.741821,1015.830811 450.903870,965.606567 426.031097,915.399536 
	C425.252106,913.827209 424.363922,912.308960 423.307159,910.360901 
	C387.865814,937.671082 352.840210,964.660889 317.542297,991.860535 
	C341.979919,1039.106201 366.258118,1086.043457 390.885468,1133.640625 
M1024.604980,465.302856 
	C1042.693115,464.768494 1060.781372,464.234131 1079.324951,463.686340 
	C1079.846191,456.535828 1080.612915,449.772125 1080.787598,442.993103 
	C1081.722290,406.745758 1082.932129,370.496826 1083.124512,334.243530 
	C1083.194702,321.038940 1080.836304,307.807800 1079.354004,294.614777 
	C1078.677246,288.589722 1074.522217,285.643494 1068.838989,285.079163 
	C1062.234009,284.423370 1055.520020,283.406158 1048.967407,283.941742 
	C1023.457458,286.026978 997.975342,288.499939 972.520813,291.187927 
	C963.656311,292.124023 954.901550,294.099731 945.531555,295.697021 
	C953.832947,353.072723 962.056519,409.910400 970.323059,467.044983 
	C988.433228,466.465790 1006.034302,465.902863 1024.604980,465.302856 
M1301.427490,877.878113 
	C1300.439941,883.782104 1298.908691,889.657959 1298.600830,895.597168 
	C1298.204834,903.238037 1294.362793,906.749878 1287.431030,909.230225 
	C1275.112549,913.638000 1263.158813,919.065063 1250.866577,924.142578 
	C1254.390991,931.006042 1257.696777,937.443481 1261.068481,944.009521 
	C1269.471436,940.127808 1277.244751,936.347595 1285.197754,932.993713 
	C1287.238281,932.133179 1290.563354,931.670105 1291.992065,932.750977 
	C1293.426147,933.835754 1293.958008,937.184265 1293.634644,939.354126 
	C1290.643188,959.418396 1287.360840,979.439148 1284.209473,999.479919 
	C1283.319458,1005.139954 1282.582153,1010.824036 1281.764160,1016.572144 
	C1286.258301,1017.468994 1289.975342,1018.210815 1294.061279,1019.026245 
	C1294.766235,1017.015381 1295.457642,1015.185425 1296.052612,1013.324524 
	C1301.366821,996.703552 1306.690430,980.085510 1311.942627,963.444824 
	C1312.935181,960.299927 1313.809814,956.986877 1318.035034,957.643005 
	C1322.719116,958.370422 1322.177856,962.141846 1321.878418,965.478516 
	C1321.105225,974.096008 1320.207642,982.702271 1319.411255,991.317810 
	C1318.484741,1001.342224 1317.612793,1011.371765 1316.629272,1022.382751 
	C1331.601929,1014.118469 1345.642334,1006.368774 1359.655884,998.633850 
	C1355.516968,975.333618 1351.324097,952.608032 1347.523804,929.817017 
	C1346.335938,922.692688 1344.437988,915.016052 1345.877808,908.231750 
	C1356.197021,859.614929 1367.321899,811.169312 1378.037231,762.635437 
	C1378.457642,760.731262 1377.992798,757.940063 1376.808716,756.479736 
	C1364.435425,741.220276 1351.836792,726.143555 1339.280029,711.033386 
	C1338.167236,709.694458 1336.908813,708.476379 1335.684814,707.166565 
	C1321.289795,717.344421 1307.364502,727.190186 1293.293457,737.138977 
	C1301.284790,749.130920 1308.970947,760.405884 1316.305664,771.905090 
	C1317.661011,774.029907 1318.455933,777.201294 1318.055908,779.652344 
	C1312.750732,812.142395 1307.185669,844.589966 1301.427490,877.878113 
M592.885803,555.368530 
	C585.845825,558.450989 578.805786,561.533447 571.678894,564.653931 
	C572.248352,565.566284 572.385681,565.880005 572.603149,566.121521 
	C611.357483,609.170410 650.146484,652.188293 688.808228,695.320190 
	C691.228638,698.020447 693.607117,698.149597 696.735535,697.710938 
	C715.507935,695.078857 734.297852,692.571899 753.081421,690.019592 
	C766.395447,688.210449 779.708801,686.395935 793.780579,684.480652 
	C788.451782,663.020508 783.230652,641.993774 777.960571,620.770020 
	C776.174622,621.036804 774.867371,621.137817 773.606445,621.435120 
	C761.312134,624.333496 748.919922,626.894775 736.784607,630.354797 
	C731.348511,631.904785 727.845398,630.581726 723.842896,627.126160 
	C685.157410,593.727234 646.336670,560.484985 607.548035,527.205505 
	C606.254761,526.095886 604.892761,525.066162 602.473145,523.125061 
	C604.395691,530.833801 605.860474,537.118835 607.554993,543.341309 
	C608.517822,546.877258 607.411072,549.159302 604.136169,550.557251 
	C600.619141,552.058472 597.106201,553.569031 592.885803,555.368530 
M1603.903442,1575.377686 
	C1617.163086,1574.262817 1630.434692,1573.265381 1643.668701,1571.901855 
	C1645.568237,1571.706055 1647.963867,1570.162598 1648.972168,1568.528687 
	C1653.685669,1560.889526 1658.044067,1553.028076 1662.398315,1545.173584 
	C1663.155029,1543.808350 1663.784790,1542.035522 1663.616089,1540.548218 
	C1662.379761,1529.645264 1660.825684,1518.778076 1659.600952,1507.874023 
	C1659.242432,1504.682007 1657.969116,1503.081665 1654.906860,1501.847656 
	C1637.798462,1494.952759 1620.747192,1487.906006 1603.816162,1480.587769 
	C1599.821899,1478.861206 1596.483887,1478.791382 1592.468506,1480.347534 
	C1557.298584,1493.979248 1522.060425,1507.434692 1486.842773,1520.943726 
	C1470.001831,1527.403320 1453.161743,1533.864990 1435.591675,1540.605591 
	C1437.626709,1541.542725 1438.919800,1542.228149 1440.276245,1542.749390 
	C1472.849243,1555.267334 1505.426025,1567.776001 1538.020386,1580.238525 
	C1539.204590,1580.691406 1540.595947,1580.922974 1541.853271,1580.816162 
	C1562.234863,1579.084351 1582.610352,1577.280884 1603.903442,1575.377686 
M1585.500000,1653.000000 
	C1603.656006,1653.000000 1621.812134,1653.032349 1639.967773,1652.946655 
	C1641.657837,1652.938721 1644.084106,1652.758789 1644.918213,1651.686279 
	C1653.469482,1640.691895 1661.762329,1629.496460 1670.081909,1618.417358 
	C1662.935547,1606.807129 1656.154419,1595.549438 1649.035034,1584.509888 
	C1648.076538,1583.023682 1645.346191,1581.739502 1643.550659,1581.875122 
	C1617.673462,1583.830322 1591.814209,1586.025391 1565.954468,1588.208496 
	C1557.702515,1588.905151 1549.461792,1589.735718 1540.950562,1590.529907 
	C1540.950562,1611.372437 1540.950562,1631.928833 1540.950562,1653.000000 
	C1555.600952,1653.000000 1570.050537,1653.000000 1585.500000,1653.000000 
M514.003113,506.421112 
	C514.880676,515.359192 515.660889,524.308899 516.726196,533.224487 
	C516.916321,534.815186 517.928589,536.712585 519.170532,537.708435 
	C528.909973,545.517883 538.729492,553.233337 548.720337,560.716187 
	C550.079407,561.734131 552.842346,562.072449 554.415710,561.421448 
	C567.622559,555.956604 580.665039,550.095642 593.851562,544.580017 
	C596.813599,543.341003 597.365601,541.934509 596.575867,538.927185 
	C593.072754,525.587280 589.728394,512.203857 586.489868,498.796783 
	C584.192017,489.283844 580.788330,479.776825 580.302734,470.144958 
	C579.449646,453.223450 580.479736,436.208496 580.618774,419.231873 
	C580.627747,418.143341 580.020935,416.350952 579.259827,416.066803 
	C573.743103,414.007324 568.112976,412.251678 562.231873,410.304901 
	C562.060364,412.114441 561.952698,413.098145 561.875732,414.084259 
	C560.659790,429.671509 559.334900,445.251526 558.304321,460.851044 
	C557.998108,465.485168 555.569885,466.863312 551.518616,466.878387 
	C547.688843,466.892670 543.856873,466.885468 540.030029,467.012848 
	C530.307190,467.336456 520.586731,467.730011 510.480560,468.110016 
	C511.689270,481.009583 512.836609,493.254547 514.003113,506.421112 
M1240.890747,1621.501221 
	C1247.881470,1630.830688 1254.973633,1640.086792 1261.796143,1649.537720 
	C1263.656250,1652.114502 1265.559326,1653.091431 1268.758667,1653.078247 
	C1300.253174,1652.949097 1331.748657,1653.000244 1363.243774,1653.000244 
	C1364.690552,1653.000244 1366.137451,1653.000122 1367.692383,1653.000122 
	C1367.692383,1642.068237 1367.692383,1631.665405 1367.692383,1621.241821 
	C1329.756104,1613.551514 1292.116943,1605.887695 1254.440186,1598.413574 
	C1253.021362,1598.132202 1250.587402,1599.242798 1249.736938,1600.472534 
	C1246.239380,1605.529541 1243.024170,1610.802734 1240.062012,1616.192505 
	C1239.422852,1617.355835 1240.264648,1619.332886 1240.890747,1621.501221 
M698.372314,1319.388550 
	C692.469482,1308.677612 686.566711,1297.966553 680.065552,1286.169922 
	C679.610962,1289.444702 679.247864,1291.398438 679.082520,1293.368530 
	C678.456482,1300.826538 677.004395,1301.961182 669.662659,1300.712524 
	C660.806396,1299.206299 651.970093,1297.523804 643.063110,1296.416626 
	C640.852661,1296.141968 637.786438,1297.136841 636.164734,1298.664307 
	C626.585327,1307.686768 617.327759,1317.050537 607.935791,1326.272705 
	C604.769714,1329.381714 601.527588,1332.413208 598.036011,1335.751831 
	C601.849487,1339.360474 605.399902,1342.376343 608.533447,1345.776489 
	C612.097168,1349.643433 616.311279,1351.394897 621.488281,1352.237427 
	C639.382935,1355.149658 657.201904,1358.525513 675.056396,1361.687378 
	C683.847290,1363.244019 692.652649,1364.718872 702.025452,1366.329346 
	C701.575256,1357.608276 701.266479,1349.496826 700.705505,1341.402832 
	C700.212036,1334.281738 699.436462,1327.180298 698.372314,1319.388550 
M532.127380,1342.216431 
	C531.560608,1339.278320 531.010010,1336.337036 530.422485,1333.403198 
	C529.853027,1330.559082 529.212891,1327.614990 532.542908,1326.009766 
	C536.046631,1324.320923 538.010254,1326.530396 539.947571,1329.106079 
	C546.645569,1338.011475 553.460510,1346.828857 560.318298,1355.794067 
	C561.269958,1355.010010 561.964844,1354.292847 562.788269,1353.783569 
	C567.248230,1351.024536 567.208374,1348.164917 564.404236,1343.717163 
	C556.776245,1331.618530 549.647705,1319.196777 542.599915,1306.745239 
	C540.336487,1302.746460 537.140564,1300.793213 533.178772,1298.658936 
	C522.309814,1292.803955 512.228394,1293.220459 502.066254,1299.829712 
	C499.874023,1301.255615 496.615540,1301.799561 495.334564,1303.734009 
	C490.564728,1310.937378 486.394958,1318.539429 482.063538,1326.028564 
	C481.676941,1326.697144 481.610046,1327.635132 481.630157,1328.442017 
	C482.065613,1345.912720 482.499878,1363.383667 483.070770,1380.850220 
	C483.111267,1382.089722 483.877106,1383.836914 484.859619,1384.429077 
	C491.941254,1388.698242 499.165894,1392.730103 506.837769,1397.118896 
	C506.956787,1395.015625 507.037201,1393.579590 507.119415,1392.143677 
	C507.909332,1378.354126 508.721863,1364.565674 509.472778,1350.774048 
	C509.645477,1347.602051 509.997131,1344.485718 513.948975,1344.150635 
	C517.865845,1343.818481 518.786560,1346.974121 519.679565,1349.900269 
	C520.844360,1353.717285 521.947083,1357.553101 523.117798,1361.368286 
	C526.956665,1373.878906 530.814270,1386.383789 534.792847,1399.307373 
	C537.797485,1398.407837 540.391174,1397.631226 543.148438,1396.805786 
	C539.467957,1378.544067 535.890991,1360.795898 532.127380,1342.216431 
M1034.456177,553.090820 
	C1038.584351,554.493347 1042.453247,554.342407 1046.432373,552.140076 
	C1050.195557,550.057251 1054.241699,548.412598 1058.301514,546.961914 
	C1061.614502,545.778015 1062.382446,543.853455 1061.901611,540.528259 
	C1060.760132,532.632751 1059.952515,524.688965 1059.013916,516.764221 
	C1057.337891,502.612823 1055.664795,488.461060 1054.057251,474.873138 
	C1038.436768,474.873138 1023.373413,474.873138 1007.903076,474.873138 
	C1005.753052,498.996155 1003.676819,522.290955 1001.564819,545.986938 
	C1012.575256,548.386230 1023.093689,550.678284 1034.456177,553.090820 
M1170.318359,1573.453857 
	C1170.705811,1578.482178 1168.827759,1581.239868 1163.344360,1581.408447 
	C1159.349121,1581.530884 1155.379395,1582.479370 1150.890259,1583.133789 
	C1157.611206,1594.164062 1163.541992,1604.780518 1170.349487,1614.801270 
	C1176.166992,1623.364380 1180.049194,1632.109741 1178.501343,1642.662231 
	C1178.367554,1643.573730 1178.618408,1644.541626 1178.768799,1646.504639 
	C1196.047607,1638.587158 1212.705322,1630.954224 1228.466919,1623.732056 
	C1227.557739,1611.341675 1237.863525,1605.206543 1240.472412,1595.531616 
	C1226.222534,1592.656494 1212.039062,1589.963867 1197.961792,1586.799072 
	C1195.414673,1586.226562 1192.548950,1584.204102 1191.129883,1582.010376 
	C1186.618896,1575.036743 1182.723999,1567.664429 1178.586060,1560.449219 
	C1176.583496,1556.957642 1174.569702,1553.472656 1172.560913,1549.984619 
	C1172.173950,1550.101685 1171.786865,1550.218750 1171.399902,1550.335815 
	C1171.078491,1557.742676 1170.756958,1565.149536 1170.318359,1573.453857 
M1639.131592,1362.660889 
	C1636.242310,1362.907104 1635.776733,1364.110107 1636.616699,1366.966187 
	C1640.268799,1379.385864 1643.599365,1391.900024 1647.073364,1404.372314 
	C1649.449341,1412.902466 1651.869141,1421.420166 1654.415161,1430.461426 
	C1668.829834,1419.739136 1684.377930,1412.979370 1701.089233,1408.753296 
	C1697.574951,1388.800659 1694.160645,1369.415527 1690.685425,1349.685059 
	C1673.357788,1354.017334 1656.625488,1358.200684 1639.131592,1362.660889 
M359.403412,1094.994995 
	C357.024414,1096.086548 354.645416,1097.178101 352.151398,1098.322266 
	C358.663513,1120.258789 362.639465,1142.646240 375.810394,1161.746094 
	C380.226715,1168.150513 383.556396,1175.302856 387.403198,1182.101807 
	C388.853943,1184.665771 390.362427,1187.197021 392.024048,1190.051514 
	C409.929749,1182.519897 427.433380,1175.157349 445.439850,1167.583496 
	C438.298706,1159.403198 431.584503,1151.711914 424.777649,1143.914551 
	C417.821350,1149.393921 411.407990,1154.418091 405.025024,1159.480591 
	C397.802246,1165.209229 396.139038,1164.830322 391.996063,1156.823853 
	C381.386047,1136.319458 370.706451,1115.851196 359.403412,1094.994995 
M697.968018,1429.538452 
	C700.422913,1431.767456 702.877869,1433.996338 706.282471,1437.087646 
	C705.014771,1415.793213 703.840820,1396.074585 702.658447,1376.214478 
	C677.555176,1371.784790 652.867371,1367.428467 626.797729,1362.828369 
	C651.087708,1385.585449 674.276306,1407.310669 697.968018,1429.538452 
M1769.166748,1647.685303 
	C1767.495361,1648.265381 1765.823853,1648.845581 1764.152466,1649.425659 
	C1796.339478,1650.124512 1828.312744,1650.145386 1860.285400,1650.041016 
	C1861.445801,1650.037231 1863.374146,1649.019897 1863.629883,1648.106934 
	C1864.864624,1643.698975 1865.648438,1639.164673 1866.651978,1634.391357 
	C1848.492188,1631.115723 1830.856567,1627.865112 1813.180176,1624.853027 
	C1811.405273,1624.550537 1808.945801,1625.139038 1807.546753,1626.249756 
	C1796.107056,1635.330566 1783.690308,1642.584717 1769.166748,1647.685303 
M550.511475,1469.048340 
	C549.869202,1468.366699 549.226868,1467.685181 548.390442,1466.797485 
	C544.234070,1471.335815 540.279968,1475.653320 536.079651,1480.239624 
	C551.006653,1490.486572 565.222046,1500.244995 579.437439,1510.003540 
	C579.670593,1509.727783 579.903687,1509.452148 580.136780,1509.176514 
	C570.401062,1495.990479 560.665344,1482.804321 550.511475,1469.048340 
M651.667297,1283.175781 
	C650.521057,1284.418945 649.374817,1285.662231 647.718201,1287.458984 
	C655.649109,1288.704834 662.573914,1289.792725 670.180176,1290.987671 
	C669.217468,1282.539917 674.223511,1274.522339 668.533203,1265.356812 
	C662.619812,1271.614868 657.394470,1277.144653 651.667297,1283.175781 
M1394.495850,1627.882690 
	C1394.852051,1627.716797 1395.208130,1627.550903 1395.564209,1627.384888 
	C1395.457397,1627.265137 1395.368530,1627.066406 1395.241211,1627.037354 
	C1389.495850,1625.730347 1383.747070,1624.438599 1377.857666,1623.113281 
	C1377.857666,1626.076172 1377.857666,1628.432251 1377.857666,1631.187866 
	C1383.490601,1630.055176 1388.658569,1629.015869 1394.495850,1627.882690 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M279.140930,1053.936035 
	C277.522614,963.432861 293.267090,876.610962 327.356567,793.237366 
	C357.343750,719.896973 399.164825,653.989807 453.326019,596.150208 
	C469.692841,578.671814 487.671570,562.708435 504.745361,545.881958 
	C508.104065,542.571899 510.319916,542.889404 513.818054,545.769287 
	C523.715576,553.917664 534.132385,561.435120 544.031372,569.581909 
	C548.190308,573.004700 551.998474,574.078796 556.584290,571.069214 
	C560.200867,568.695679 562.643982,569.338867 565.700623,572.754944 
	C604.901428,616.565002 644.337891,660.164185 683.567932,703.948242 
	C686.627747,707.363281 689.651062,708.384583 694.024963,707.771973 
	C718.411804,704.356628 742.834900,701.200317 767.218201,697.761108 
	C770.220093,697.337708 772.148499,697.806274 774.074097,700.199280 
	C777.830139,704.867065 782.056396,709.157410 785.796692,713.836853 
	C788.030273,716.631226 790.434265,717.670471 793.991577,717.090454 
	C812.048279,714.146423 830.130981,711.362061 848.203125,708.512634 
	C861.961975,706.343384 875.718750,704.160583 889.861572,701.922791 
	C891.258728,717.365540 892.642090,732.420471 893.978699,747.479675 
	C896.583069,776.821533 899.182312,806.163879 901.743896,835.509521 
	C903.885925,860.049377 905.956848,884.595459 908.085938,909.136414 
	C910.071106,932.018188 911.985657,954.907532 914.279236,977.758606 
	C914.482361,979.782715 916.958435,982.747437 918.889343,983.229309 
	C927.738586,985.437744 929.692322,990.477417 929.379883,999.385803 
	C928.014404,1038.321289 927.620789,1077.290161 926.797424,1116.245361 
	C926.199341,1144.543823 925.444946,1172.838989 924.823608,1201.136963 
	C923.793091,1248.077637 922.825623,1295.019531 921.808105,1341.960449 
	C921.165833,1371.591309 920.380249,1401.219360 919.858765,1430.852295 
	C919.606873,1445.162964 919.815369,1459.481689 919.815369,1473.796753 
	C919.275208,1473.827271 918.735107,1473.857788 918.194946,1473.888306 
	C915.800598,1458.538452 913.381836,1443.192383 911.016602,1427.838013 
	C905.165344,1389.854126 899.343872,1351.865723 893.500244,1313.880737 
	C888.998169,1284.616211 884.536743,1255.345093 879.885315,1226.104248 
	C879.407227,1223.098999 878.301086,1219.894287 876.564148,1217.432739 
	C839.891296,1165.459717 803.053345,1113.603149 766.379517,1061.630737 
	C763.929138,1058.158203 761.316223,1057.396851 757.480957,1058.278320 
	C734.307373,1063.604492 711.095459,1068.765991 687.956421,1074.236816 
	C685.861267,1074.732300 683.459167,1076.633545 682.432922,1078.544434 
	C663.936523,1112.988525 645.574036,1147.505493 627.421143,1182.131470 
	C626.323059,1184.226074 627.205750,1187.364014 627.185486,1190.016724 
	C627.172974,1191.646973 627.902649,1193.899414 627.097107,1194.814697 
	C614.789612,1208.800781 602.283691,1222.612305 589.605347,1236.707642 
	C587.712402,1235.644775 585.980713,1234.729370 584.303894,1233.722656 
	C543.486023,1209.217163 502.664062,1184.718384 461.879089,1160.158325 
	C458.503998,1158.125854 455.362366,1156.546753 452.037048,1160.536011 
	C446.925537,1154.651123 442.142639,1149.144531 436.893585,1143.101196 
	C444.086578,1139.358032 450.927765,1135.737915 457.821716,1132.221436 
	C483.013092,1119.371582 508.227570,1106.567017 533.421204,1093.721558 
	C541.132568,1089.789795 541.386597,1088.843750 537.626221,1081.127563 
	C515.912659,1036.571899 494.211670,992.010132 472.525421,947.441223 
	C469.616058,941.461914 468.600891,940.982971 462.006165,943.000244 
	C458.987183,943.923767 455.976196,944.873352 452.958862,945.802246 
	C452.812531,945.847351 452.640259,945.808228 451.829620,945.808228 
	C449.236694,940.604675 446.511566,935.145325 443.795013,929.681763 
	C439.350861,920.743652 434.934143,911.791870 430.463654,902.867004 
	C427.580139,897.110352 425.338562,896.624390 420.070465,900.680847 
	C393.676239,921.004333 367.303741,941.355957 340.919922,961.692993 
	C331.026306,969.318970 321.120361,976.929016 311.225006,984.552734 
	C305.842529,988.699585 305.617798,989.688354 308.778778,995.799255 
	C323.453003,1024.167847 338.139618,1052.530029 352.813110,1080.899048 
	C353.575562,1082.373169 354.257812,1083.888794 355.217407,1085.884155 
	C352.131836,1087.505859 349.193207,1089.323242 346.044067,1090.635376 
	C342.227936,1092.225342 341.100037,1094.859985 342.170502,1098.605591 
	C346.511200,1113.793213 350.687164,1129.033691 355.404205,1144.104492 
	C356.768951,1148.464844 359.698914,1152.344971 361.977905,1156.407837 
	C369.306274,1169.472168 376.657837,1182.523560 384.016632,1195.570801 
	C387.464600,1201.683960 388.300110,1201.979858 394.612274,1199.340576 
	C404.125275,1195.363159 413.624329,1191.352173 423.138245,1187.376831 
	C424.471344,1186.819824 425.855194,1186.384155 427.691681,1186.545044 
	C419.554291,1195.195679 411.417542,1203.847046 403.278473,1212.496094 
	C402.593658,1213.223755 401.860199,1213.907715 401.205322,1214.660767 
	C397.232513,1219.229614 397.608643,1221.849731 402.807587,1224.954956 
	C427.385712,1239.633545 451.981201,1254.283203 476.569672,1268.944580 
	C486.401917,1274.807129 496.232086,1280.673218 506.972748,1287.080200 
	C501.857666,1289.363281 497.411316,1291.010864 493.322906,1293.298218 
	C490.845428,1294.684204 488.546021,1296.779297 486.840668,1299.059937 
	C484.464417,1302.237671 483.165436,1306.265381 480.623444,1309.266968 
	C471.254272,1320.329956 471.322113,1333.262817 472.464478,1346.540161 
	C472.777863,1350.182739 473.752625,1354.181396 472.649719,1357.410645 
	C471.652557,1360.330200 468.562134,1362.924927 465.790192,1364.739136 
	C462.971497,1366.584229 459.224091,1366.947510 456.210602,1368.568115 
	C434.384369,1380.307007 412.640991,1392.199829 390.604492,1404.189209 
	C389.721161,1403.106201 388.819641,1402.176270 388.117035,1401.114624 
	C341.012238,1329.930420 308.682495,1252.630737 291.880402,1168.878174 
	C285.024139,1134.702271 280.789795,1100.233765 279.642212,1065.390747 
	C279.521820,1061.734985 279.328613,1058.081543 279.140930,1053.936035 
M678.856995,845.652222 
	C676.566345,843.718933 674.096558,841.958374 672.026672,839.812195 
	C668.872925,836.542114 665.640930,836.589661 661.626099,838.179871 
	C621.750061,853.974243 581.819702,869.631714 541.909607,885.340210 
	C535.079041,888.028625 534.684326,888.880127 536.441711,896.175781 
	C541.657837,917.830383 546.879578,939.483765 552.070068,961.144592 
	C560.127014,994.767517 568.156128,1028.397095 576.206482,1062.021729 
	C577.632507,1067.978027 578.715820,1068.765259 584.828308,1068.129395 
	C624.049500,1064.048828 663.275635,1060.011475 702.470703,1055.692505 
	C704.785461,1055.437378 707.824829,1053.359863 708.875366,1051.291504 
	C723.867249,1021.775696 738.572693,992.114258 753.350891,962.489868 
	C757.765137,953.641052 762.190674,944.797913 766.903931,935.366089 
	C773.735291,951.721436 775.696411,968.076721 777.085144,984.632446 
	C779.046021,1008.008606 781.436523,1031.350952 783.947815,1054.674927 
	C784.179565,1056.828003 786.146057,1059.691284 788.081116,1060.631104 
	C824.725098,1078.429932 861.463501,1096.035522 898.283691,1113.466919 
	C900.241455,1114.393677 904.099487,1114.352661 905.255066,1113.093628 
	C906.476746,1111.762573 906.295410,1108.094360 905.391968,1106.031616 
	C899.322266,1092.172241 892.765991,1078.526489 886.625610,1064.697021 
	C880.903503,1051.809692 873.976868,1039.199707 870.271729,1025.727539 
	C862.254028,996.574341 855.912781,966.958191 849.016724,937.500793 
	C848.145447,933.779053 846.374329,931.838623 842.569519,931.027344 
	C818.831360,925.965820 795.134583,920.710815 771.409790,915.585754 
	C769.666626,915.209229 767.261108,914.584656 766.120239,915.405334 
	C763.527161,917.270752 762.061035,916.114136 760.227600,914.559753 
	C733.298340,891.728333 706.348328,868.921265 678.856995,845.652222 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M1188.864258,1154.891113 
	C1190.169067,1122.475830 1191.552246,1090.548828 1192.727783,1058.614380 
	C1193.382935,1040.810669 1193.801392,1022.995911 1194.064331,1005.182312 
	C1194.115234,1001.728760 1195.000854,999.812378 1198.498535,999.451904 
	C1198.659912,999.435303 1198.811768,999.339783 1198.972168,999.296570 
	C1214.849487,995.016724 1212.768799,997.456970 1212.865234,981.274902 
	C1213.008301,957.279419 1213.035156,933.283203 1213.194458,909.287842 
	C1213.493164,864.307800 1213.832153,819.328064 1214.192261,774.348450 
	C1214.378906,751.032471 1214.647827,727.717102 1214.875000,704.401489 
	C1214.893921,702.452637 1214.877563,700.503418 1214.877563,697.253723 
	C1222.756348,704.865540 1229.775391,711.577759 1236.716553,718.369629 
	C1246.244263,727.692383 1255.705444,737.083069 1265.209595,746.429810 
	C1271.180420,752.301758 1271.764038,752.331848 1278.613770,747.482544 
	C1280.770874,745.955383 1282.940308,744.445618 1285.416992,742.708374 
	C1293.046143,754.144470 1300.567261,765.292175 1307.880981,776.574341 
	C1308.627686,777.725952 1308.421509,779.734436 1308.164429,781.262390 
	C1301.789062,819.152832 1295.391357,857.039795 1288.780640,894.889526 
	C1288.465332,896.694275 1286.480225,898.896606 1284.728760,899.651428 
	C1271.597534,905.311035 1258.326050,910.644958 1245.105469,916.097717 
	C1238.969482,918.628540 1238.282349,920.399780 1241.251709,926.339233 
	C1245.343018,934.522766 1249.643188,942.605164 1253.578247,950.862305 
	C1255.616089,955.138306 1258.363037,955.930237 1262.427612,954.014709 
	C1269.022949,950.906494 1275.662720,947.892761 1283.142456,944.443176 
	C1281.883301,952.688232 1280.758057,960.151550 1279.601807,967.610107 
	C1277.002563,984.377441 1274.461060,1001.154297 1271.729492,1017.900146 
	C1271.023071,1022.230225 1272.385254,1024.550537 1276.739502,1025.347412 
	C1282.622681,1026.424316 1288.480957,1027.651001 1294.322510,1028.937256 
	C1299.185303,1030.007935 1301.812866,1028.184448 1303.006226,1023.341187 
	C1304.140381,1018.738403 1305.845459,1014.276245 1308.136475,1009.938843 
	C1307.539917,1016.021423 1306.713135,1022.094727 1306.468872,1028.191406 
	C1306.380615,1030.393433 1307.060303,1033.425293 1308.557373,1034.641846 
	C1309.781616,1035.636963 1313.097534,1035.159912 1314.875122,1034.201782 
	C1331.866577,1025.042969 1348.710205,1015.610779 1365.641357,1006.338989 
	C1369.035156,1004.480347 1370.058228,1002.246460 1369.313965,998.214844 
	C1364.392822,971.555542 1359.610352,944.867249 1355.223999,918.116028 
	C1354.479004,913.573059 1355.328369,908.562866 1356.345215,903.968567 
	C1366.911011,856.234497 1377.625732,808.533203 1388.438354,760.854431 
	C1389.194458,757.520569 1388.516479,755.216003 1386.403076,752.690308 
	C1372.296265,735.832397 1358.309570,718.873840 1343.898071,701.482422 
	C1345.991455,699.975159 1347.938965,698.568298 1349.891357,697.168091 
	C1355.257202,693.320007 1355.513062,691.581299 1351.468750,686.243225 
	C1333.465210,662.479919 1315.460571,638.717468 1297.453857,614.956604 
	C1282.664795,595.441467 1267.961182,575.860229 1252.966553,556.504395 
	C1251.140747,554.147583 1247.929810,551.994385 1245.044067,551.461121 
	C1212.497437,545.447510 1179.886841,539.781433 1147.297974,533.996338 
	C1127.487793,530.479675 1107.680298,526.946411 1087.882324,523.361938 
	C1080.630615,522.048950 1079.588379,522.648743 1077.782104,529.707703 
	C1076.116821,536.215393 1074.411377,542.712830 1072.487061,550.126282 
	C1069.491333,524.257202 1066.620605,499.468506 1063.664673,473.942993 
	C1069.729370,473.663483 1075.466919,473.396240 1081.204712,473.135315 
	C1087.483398,472.849823 1088.553467,471.754791 1088.901611,465.393219 
	C1089.929321,446.615997 1090.968628,427.839447 1092.026855,409.063965 
	C1092.081421,408.098511 1092.354858,407.145416 1092.655151,405.467560 
	C1197.887451,432.450012 1290.850342,481.865479 1371.049805,554.667725 
	C1475.806030,649.761902 1542.883179,766.841919 1573.719116,906.438049 
	C1569.933838,903.787292 1567.290771,901.989929 1564.703369,900.115417 
	C1550.946899,890.149109 1537.151855,880.234558 1523.496338,870.131592 
	C1520.291626,867.760559 1517.474365,867.453735 1513.858398,869.129822 
	C1486.697632,881.719360 1459.503662,894.238953 1432.233643,906.589417 
	C1428.294312,908.373535 1426.695801,910.600281 1427.055420,914.975220 
	C1429.714233,947.318970 1432.211426,979.676025 1434.744873,1012.030029 
	C1435.784180,1025.304199 1436.676514,1038.591797 1437.924805,1051.845947 
	C1438.116455,1053.880615 1439.412109,1056.309082 1440.975830,1057.641235 
	C1462.784058,1076.220093 1484.694336,1094.680054 1506.709839,1113.012573 
	C1508.286987,1114.325806 1510.996582,1115.240723 1512.978027,1114.952881 
	C1527.294312,1112.874390 1541.552368,1110.399170 1555.843262,1108.140259 
	C1559.832397,1107.509766 1560.068359,1104.364624 1560.643677,1101.469727 
	C1564.435913,1082.386108 1568.188721,1063.294434 1571.929932,1044.200806 
	C1575.671265,1025.107178 1579.378418,1006.006775 1583.123779,986.914001 
	C1583.373779,985.639526 1583.821533,984.403870 1584.288940,982.756653 
	C1589.262939,1009.104553 1587.281372,1099.685913 1581.201904,1125.758423 
	C1578.329102,1125.758423 1575.376953,1125.933105 1572.450928,1125.730713 
	C1550.200928,1124.191406 1527.948364,1122.674438 1505.715942,1120.907959 
	C1501.184326,1120.547974 1499.223877,1122.157959 1497.837158,1126.379517 
	C1487.360229,1158.274536 1476.660522,1190.096191 1466.027466,1221.939819 
	C1465.581909,1223.273926 1465.108032,1224.598633 1464.647339,1225.927734 
	C1464.056763,1225.873169 1463.466187,1225.818604 1462.875610,1225.764038 
	C1462.875610,1207.493530 1463.005371,1189.221802 1462.837280,1170.952881 
	C1462.685547,1154.468750 1462.238159,1137.986938 1461.854858,1121.505737 
	C1461.742310,1116.657715 1459.559448,1114.864014 1454.922119,1115.538574 
	C1412.447754,1121.716431 1369.980347,1127.942139 1327.490723,1134.012573 
	C1323.294556,1134.611938 1322.092773,1137.181396 1321.255127,1140.619019 
	C1313.539673,1172.282104 1305.793213,1203.937622 1298.048462,1235.593506 
	C1294.531616,1249.967773 1291.110107,1264.366943 1287.409302,1278.693726 
	C1286.185669,1283.430908 1287.110718,1286.461182 1291.650269,1288.888916 
	C1299.861328,1293.280273 1307.729492,1298.308228 1315.877075,1302.824707 
	C1318.359009,1304.200562 1318.809937,1305.612915 1318.512817,1308.364136 
	C1314.883789,1341.957275 1311.446045,1375.571045 1307.935059,1409.177002 
	C1305.254272,1434.836548 1302.542236,1460.492798 1299.824951,1486.148560 
	C1299.760254,1486.759644 1299.468750,1487.346680 1299.131592,1488.432983 
	C1297.073608,1487.726196 1295.221680,1487.149902 1293.413696,1486.459473 
	C1278.811523,1480.883423 1264.273560,1475.130737 1249.569824,1469.837769 
	C1246.918579,1468.883423 1243.252075,1468.934570 1240.638306,1469.980591 
	C1221.650879,1477.579956 1202.825439,1485.582764 1183.919800,1493.387939 
	C1178.918945,1495.452637 1173.541992,1497.025757 1175.059082,1504.859497 
	C1174.506592,1504.613159 1173.954224,1504.366699 1173.401733,1504.120361 
	C1178.553101,1387.872314 1183.704590,1271.624268 1188.864258,1154.891113 
z"
      />
      <path
        fill="#94C11F"
        opacity="1.000000"
        stroke="none"
        d="
M1109.072754,536.941284 
	C1152.889526,544.690308 1196.275635,552.401611 1239.673462,560.045837 
	C1242.931641,560.619751 1245.285645,561.909485 1247.382446,564.691345 
	C1277.955566,605.252747 1308.667725,645.709290 1339.338989,686.196655 
	C1340.333008,687.508850 1341.244385,688.883728 1342.458862,690.604309 
	C1319.174561,707.044556 1296.083252,723.348694 1272.585815,739.939453 
	C1267.904175,735.399902 1263.285156,730.945740 1258.693359,726.463867 
	C1244.269287,712.385132 1229.917358,698.231140 1215.352539,684.299622 
	C1213.683472,682.703186 1209.951782,680.938354 1208.758545,681.707214 
	C1206.906616,682.900391 1205.513672,686.193848 1205.483521,688.616272 
	C1205.098999,719.601501 1205.002319,750.590210 1204.812256,781.577881 
	C1204.487305,834.549500 1204.177124,887.521118 1203.795410,940.492371 
	C1203.689819,955.140503 1203.243164,969.786743 1203.209839,984.434448 
	C1203.202637,987.631287 1202.030640,988.623047 1199.143921,989.402771 
	C1151.157227,1002.365234 1103.210571,1015.475220 1055.221191,1028.426880 
	C1053.324707,1028.938721 1050.869385,1028.742310 1049.050537,1027.979248 
	C1008.419983,1010.932617 967.851074,993.739136 927.235352,976.657104 
	C924.457764,975.488892 923.240234,973.993713 922.972717,970.840454 
	C919.470520,929.551147 915.774841,888.278320 912.182922,846.996582 
	C909.038086,810.853088 905.986816,774.701477 902.844055,738.557800 
	C901.705322,725.461426 900.463806,712.373535 899.187256,699.289734 
	C898.470215,691.940735 897.350220,691.016174 890.090515,692.137146 
	C874.639832,694.522705 859.211487,697.053467 843.773315,699.520752 
	C828.334229,701.988281 812.886292,704.402710 797.461426,706.956177 
	C794.361633,707.469299 792.076416,706.977112 790.163513,704.227844 
	C788.222900,701.438660 785.815308,698.974426 783.034790,695.684692 
	C789.032410,694.851807 794.071777,694.083252 799.130005,693.470032 
	C803.665771,692.920166 805.136719,690.418335 804.080811,686.172668 
	C798.142578,662.293518 792.163574,638.424438 786.272888,614.533630 
	C785.222412,610.273315 782.564758,609.409851 778.758484,610.325439 
	C772.467957,611.838806 766.175842,613.345154 759.207581,615.016907 
	C759.403137,611.027283 759.196960,607.380920 759.950745,603.945251 
	C760.229004,602.676941 762.638428,601.422668 764.295044,600.977356 
	C796.403137,592.345032 828.540344,583.820740 860.678711,575.301147 
	C897.477539,565.546265 934.282959,555.816528 971.087708,546.083801 
	C972.195740,545.790771 973.327271,545.586670 974.887146,545.244812 
	C980.294678,555.861267 985.730957,566.490356 991.128479,577.139221 
	C1007.446655,609.333801 1023.742737,641.539551 1040.070557,673.729309 
	C1041.541870,676.629822 1042.522827,680.381958 1046.906616,679.823486 
	C1051.031982,679.297791 1051.101929,675.528381 1051.841675,672.582458 
	C1063.260864,627.110535 1074.619873,581.623474 1086.003906,536.142700 
	C1086.241089,535.195557 1086.612061,534.281860 1087.035645,533.006042 
	C1094.305786,534.311707 1101.475342,535.599304 1109.072754,536.941284 
z"
      />
      <path
        fill="#94C11F"
        opacity="1.000000"
        stroke="none"
        d="
M1054.652588,1378.007324 
	C1054.318970,1345.033569 1054.000610,1312.558350 1053.647339,1280.083496 
	C1053.335938,1251.438599 1052.992676,1222.794189 1052.650269,1194.149658 
	C1052.403442,1173.501465 1052.106689,1152.853638 1051.902466,1132.205078 
	C1051.867676,1128.678467 1051.044922,1125.465210 1047.097534,1125.311035 
	C1043.061646,1125.153687 1042.166870,1128.270142 1042.067139,1131.857056 
	C1041.372681,1156.817261 1040.592041,1181.775269 1039.811890,1206.733032 
	C1038.485840,1249.155273 1037.153809,1291.577515 1035.798462,1333.998779 
	C1034.825806,1364.442261 1033.792480,1394.883911 1032.819580,1425.327393 
	C1031.464111,1467.749023 1030.096924,1510.170288 1028.838379,1552.594727 
	C1028.587280,1561.058472 1028.802002,1569.535889 1028.802002,1578.471069 
	C1023.834961,1579.463013 1019.851868,1580.463501 1015.807495,1581.012695 
	C1011.044678,1581.659302 1009.300232,1584.015747 1009.819519,1588.817017 
	C1011.842041,1607.514526 1013.664734,1626.233521 1015.556702,1644.945068 
	C1015.772705,1647.080811 1015.956726,1649.219849 1016.220276,1652.053589 
	C969.667542,1651.472168 923.477051,1650.895142 876.716553,1650.311157 
	C876.925964,1646.038330 876.690186,1642.182739 877.461548,1638.540283 
	C877.886780,1636.532349 879.613342,1634.050049 881.419800,1633.203247 
	C895.871155,1626.428101 910.742737,1620.505127 924.949646,1613.268799 
	C934.080444,1608.618164 942.424927,1602.361084 950.880188,1596.476685 
	C954.556091,1593.918579 953.709351,1589.849243 949.368347,1587.977905 
	C943.261841,1585.345581 937.119080,1582.761475 930.854187,1580.545776 
	C927.256104,1579.273193 925.764709,1577.630005 925.885925,1573.474487 
	C926.807861,1541.856934 927.439880,1510.230713 928.137268,1478.606689 
	C928.834717,1446.981079 929.504578,1415.354980 930.184570,1383.729004 
	C931.186523,1337.123291 932.166260,1290.517212 933.195129,1243.912109 
	C933.819702,1215.617432 934.556152,1187.325073 935.176086,1159.030151 
	C936.208130,1111.924561 937.212280,1064.818115 938.164307,1017.710754 
	C938.332092,1009.407593 938.188110,1001.098022 938.188110,991.712952 
	C946.810913,995.328674 954.248230,998.426880 961.669617,1001.562988 
	C990.004761,1013.536438 1018.301453,1025.602295 1046.718872,1037.376953 
	C1049.521973,1038.538574 1053.284546,1038.812378 1056.211426,1038.032593 
	C1097.333252,1027.078857 1138.386719,1015.868286 1179.459717,1004.731262 
	C1181.017822,1004.308716 1182.606567,1003.999329 1185.534180,1003.325989 
	C1177.347656,1193.295776 1169.196655,1382.440063 1161.028564,1571.982300 
	C1155.143433,1572.712402 1149.573364,1573.385010 1144.008545,1574.098877 
	C1138.128052,1574.853027 1136.521606,1577.993530 1139.587036,1583.054688 
	C1147.606323,1596.294434 1155.532471,1609.596558 1163.866211,1622.637085 
	C1167.580078,1628.448608 1169.932739,1634.277466 1169.056274,1641.272583 
	C1168.712280,1644.018555 1169.000000,1646.843750 1169.000000,1649.874023 
	C1133.940918,1649.874023 1099.366699,1649.874023 1064.241821,1649.874023 
	C1064.541504,1641.968872 1063.295044,1634.357788 1066.400391,1626.699097 
	C1071.707153,1613.610352 1076.325073,1600.241211 1081.189697,1586.974243 
	C1083.644409,1580.279541 1082.258423,1578.255737 1075.127808,1577.808960 
	C1069.188721,1577.436768 1063.252808,1577.015869 1056.892700,1576.588013 
	C1056.143433,1510.327271 1055.398071,1444.416748 1054.652588,1378.007324 
z"
      />
      <path
        fill="#94C11F"
        opacity="1.000000"
        stroke="none"
        d="
M1324.827393,1166.804932 
	C1326.553955,1159.786499 1328.070801,1153.136963 1329.934326,1146.585815 
	C1330.329224,1145.197998 1331.857666,1143.289307 1333.086792,1143.104614 
	C1371.741821,1137.295410 1410.424194,1131.668335 1449.105103,1126.031982 
	C1449.908081,1125.914917 1450.742920,1126.017212 1453.000000,1126.017212 
	C1453.000000,1135.175903 1452.889038,1144.255005 1453.020752,1153.330566 
	C1453.412476,1180.304810 1453.879028,1207.278320 1454.365112,1234.251221 
	C1454.475952,1240.404785 1454.844971,1246.553467 1454.975098,1252.707031 
	C1455.046387,1256.087891 1454.573364,1259.835938 1459.187988,1260.449463 
	C1463.391602,1261.008301 1464.184082,1257.638306 1465.215820,1254.534058 
	C1476.114624,1221.739380 1487.075073,1188.965088 1498.012451,1156.183105 
	C1500.431274,1148.932983 1502.954102,1141.713745 1505.169189,1134.401367 
	C1506.053345,1131.482666 1507.433716,1130.584106 1510.488525,1130.820190 
	C1532.224365,1132.500122 1553.973267,1134.010376 1575.719360,1135.556274 
	C1587.339722,1136.382202 1598.975586,1137.030273 1610.574707,1138.085205 
	C1613.170532,1138.321289 1616.181763,1139.314575 1618.085571,1140.996216 
	C1633.811523,1154.886963 1649.355835,1168.984619 1664.841309,1183.144165 
	C1666.313110,1184.489868 1667.513672,1186.563110 1667.987305,1188.506470 
	C1679.600708,1236.156006 1691.100952,1283.832886 1702.606934,1331.508545 
	C1702.954346,1332.948486 1703.147461,1334.425537 1703.533569,1336.550903 
	C1677.821899,1342.993408 1652.259277,1349.398682 1626.184570,1355.932129 
	C1623.422729,1345.250488 1620.687378,1334.661255 1617.946777,1324.073364 
	C1613.031494,1305.082886 1608.089844,1286.099121 1603.222656,1267.096436 
	C1602.520020,1264.353760 1601.833496,1261.854004 1598.266113,1262.008789 
	C1594.622559,1262.166992 1593.674683,1264.738159 1593.104370,1267.694946 
	C1579.369995,1338.887085 1565.610352,1410.074707 1551.952515,1481.281616 
	C1551.289062,1484.740723 1549.875610,1486.663208 1546.460571,1487.958130 
	C1506.194336,1503.224731 1466.008423,1518.703613 1425.727905,1533.932251 
	C1423.362183,1534.826660 1420.073242,1534.837036 1417.709717,1533.944946 
	C1382.712402,1520.737793 1347.817993,1507.258545 1312.835205,1494.012451 
	C1309.524170,1492.758789 1308.691650,1491.145996 1309.056885,1487.786621 
	C1313.680542,1445.266602 1318.190552,1402.734375 1322.710205,1360.203003 
	C1324.714966,1341.338135 1326.821777,1322.481323 1328.453613,1303.583740 
	C1328.635010,1301.482666 1326.536377,1298.296021 1324.580078,1297.051514 
	C1315.615967,1291.349609 1306.326172,1286.159424 1296.865479,1280.616943 
	C1306.184326,1242.704956 1315.462891,1204.956909 1324.827393,1166.804932 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M627.894043,1377.116211 
	C653.664490,1401.283813 679.209595,1425.173950 704.632935,1449.192993 
	C705.993591,1450.478394 706.900818,1452.804565 707.048279,1454.720947 
	C707.903320,1465.835693 708.461182,1476.973145 709.131775,1488.102173 
	C709.478638,1493.858887 710.825012,1495.187378 716.418457,1495.015991 
	C752.529785,1493.908936 788.640930,1492.796753 824.750488,1491.633545 
	C840.886597,1491.113892 857.018433,1490.463379 873.153076,1489.895874 
	C875.287109,1489.820801 877.426086,1489.885620 880.128052,1489.885620 
	C872.453491,1536.550415 864.859314,1582.726685 857.279480,1628.815552 
	C839.387695,1628.815552 822.080872,1628.924316 804.775879,1628.792358 
	C771.462708,1628.538330 738.150330,1628.162231 704.838074,1627.802490 
	C697.849487,1627.727051 690.856750,1627.271729 683.877197,1627.445435 
	C680.394775,1627.531982 678.474609,1626.120483 676.538208,1623.490601 
	C647.404419,1583.925415 618.181702,1544.425903 588.981384,1504.909790 
	C577.598328,1489.505371 566.222351,1474.095459 554.836548,1458.693115 
	C550.579285,1452.933838 548.366150,1452.790405 543.498047,1458.013916 
	C504.212708,1500.168213 464.886932,1542.284912 425.754913,1584.581055 
	C422.844543,1587.726685 420.790192,1587.912598 417.450592,1585.914062 
	C413.890991,1583.783813 410.094788,1582.033936 406.339386,1580.249512 
	C401.826813,1578.105103 398.862793,1579.660400 398.282318,1584.712402 
	C396.439331,1600.752319 394.757904,1616.810791 392.995422,1632.859985 
	C392.778992,1634.830811 392.449799,1636.789185 392.089172,1639.347412 
	C390.293854,1639.347412 388.676697,1639.347412 387.059540,1639.347412 
	C331.059570,1639.347412 275.059357,1639.284302 219.059967,1639.461792 
	C214.366562,1639.476685 213.076767,1637.940308 212.913528,1633.580933 
	C212.677948,1627.289795 211.805939,1621.022583 211.160431,1614.273926 
	C223.778381,1610.511108 236.250854,1606.507446 248.879990,1603.081299 
	C280.706635,1594.447266 311.799774,1583.843018 341.705963,1569.851685 
	C349.483154,1566.213257 349.999908,1563.539917 343.290405,1557.904907 
	C332.453217,1548.803223 321.564392,1539.762939 310.153931,1530.243408 
	C364.277252,1477.985718 418.145020,1425.974609 473.350433,1372.672119 
	C473.350433,1377.229736 473.421967,1380.404785 473.332184,1383.575073 
	C473.222595,1387.445679 474.712921,1390.037231 478.266907,1391.968628 
	C487.917603,1397.213013 497.374023,1402.813965 506.934052,1408.226685 
	C512.716309,1411.500366 515.636292,1409.871826 516.011108,1403.303467 
	C516.462830,1395.388672 516.960938,1387.476440 518.464233,1379.314331 
	C519.626404,1382.917847 520.819397,1386.511597 521.943237,1390.127075 
	C523.523193,1395.209717 525.105835,1400.292847 526.585144,1405.405273 
	C527.750977,1409.434326 530.191650,1410.642456 534.172974,1409.437622 
	C538.469116,1408.137695 542.843506,1407.098877 547.167114,1405.886597 
	C553.213257,1404.191162 554.089172,1402.829712 552.849915,1396.548706 
	C550.112061,1382.671387 547.285156,1368.811768 544.509521,1354.941772 
	C544.289368,1353.841553 544.185974,1352.717896 543.835388,1350.243042 
	C548.058594,1355.707642 551.434631,1360.179321 554.923706,1364.560791 
	C558.178955,1368.648560 560.163635,1368.849976 564.013184,1365.516602 
	C567.791077,1362.245239 571.378845,1358.748169 575.236877,1355.577271 
	C578.682617,1352.745361 579.169312,1349.847168 576.812805,1346.023071 
	C572.454712,1338.951050 568.351074,1331.722168 564.617920,1323.270264 
	C566.396118,1323.725220 568.600830,1323.662476 569.883301,1324.719116 
	C578.080872,1331.473633 586.245483,1338.287842 594.096619,1345.438599 
	C605.423584,1355.755371 616.474487,1366.375244 627.894043,1377.116211 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M1055.220093,619.211731 
	C1051.733765,633.245239 1048.342651,646.877136 1044.716675,661.452942 
	C1038.754883,649.750488 1033.241089,638.966431 1027.761841,628.164795 
	C1012.786926,598.643738 997.768250,569.144653 982.926575,539.556763 
	C980.806763,535.330750 978.195190,534.232971 973.726257,535.421692 
	C901.428650,554.651062 829.119629,573.838135 756.764099,592.847961 
	C751.741516,594.167542 749.845642,596.585693 750.064392,601.549927 
	C750.247253,605.699341 750.194092,609.908081 749.658875,614.014099 
	C749.467407,615.483337 747.577454,616.745911 746.412048,618.057678 
	C746.234131,618.257996 745.756714,618.158936 745.458313,618.290222 
	C736.390686,622.282410 729.688354,619.825378 722.091858,613.140137 
	C684.338379,579.915588 645.931213,547.433228 607.688293,514.766846 
	C605.418396,512.827881 602.573364,511.562378 599.047668,509.402588 
	C597.259521,502.315247 595.313965,493.900696 592.958496,485.602478 
	C591.968994,482.116455 593.761780,480.903717 596.203003,479.436676 
	C624.485474,462.440125 653.851624,447.606140 684.342651,434.990387 
	C737.202637,413.119415 792.059265,398.766388 848.722778,391.142792 
	C877.844788,387.224670 929.696228,384.612549 948.868713,386.309662 
	C950.535767,397.467010 952.269409,408.746185 953.897095,420.040619 
	C956.340820,436.998199 958.732056,453.963440 961.095825,470.932373 
	C961.680115,475.126434 963.804138,476.883240 968.165710,476.783752 
	C977.940430,476.560822 987.723633,476.713959 998.039001,476.713959 
	C997.282349,485.713806 996.517761,495.095490 995.699524,504.472443 
	C994.455444,518.729980 993.256775,532.992310 991.861938,547.235229 
	C991.402344,551.928467 992.997864,554.176086 997.799805,555.109558 
	C1011.019226,557.679504 1024.131714,560.796387 1037.337158,563.444275 
	C1039.796631,563.937439 1042.755615,563.912048 1045.031738,562.998718 
	C1053.970581,559.412170 1062.728638,555.374939 1072.319824,551.169128 
	C1066.585693,573.978333 1060.950439,596.394226 1055.220093,619.211731 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M640.857300,1177.879150 
	C648.151367,1163.880615 655.395081,1149.855591 662.752502,1135.890381 
	C671.359680,1119.553345 679.988403,1103.226074 688.834167,1087.018188 
	C689.858704,1085.140869 692.126892,1083.210938 694.157349,1082.726929 
	C714.697876,1077.831787 735.331848,1073.329102 755.876587,1068.450928 
	C759.080505,1067.690186 759.972595,1069.408325 761.324158,1071.316772 
	C794.619324,1118.332397 827.500916,1165.651245 861.537842,1212.123779 
	C870.143372,1223.873535 871.871643,1236.553833 873.929504,1249.708984 
	C879.893127,1287.832153 885.680542,1325.982788 891.547241,1364.121094 
	C897.338318,1401.768188 903.142883,1439.413330 908.927246,1477.061401 
	C909.000732,1477.539429 908.886047,1478.046387 908.828430,1479.107544 
	C845.700256,1481.226685 782.558960,1483.346069 718.768494,1485.487305 
	C718.157593,1476.080078 717.541565,1467.181274 717.008179,1458.277466 
	C714.729004,1420.231934 712.473755,1382.184937 710.210876,1344.138550 
	C709.875000,1338.489624 709.150635,1332.828979 709.316833,1327.194580 
	C709.507996,1320.718750 707.261353,1315.325806 704.158997,1309.849243 
	C695.466675,1294.505127 687.234619,1278.900269 678.545044,1263.554688 
	C676.616821,1260.149414 677.005432,1258.245361 679.745667,1255.575073 
	C710.526367,1225.580200 741.137085,1195.410889 771.917969,1165.416016 
	C775.358826,1162.062988 776.320984,1159.201660 774.359497,1154.498291 
	C769.179749,1142.077881 764.525818,1129.433472 759.874695,1116.800049 
	C758.417664,1112.842285 756.189453,1111.130859 751.841492,1110.903687 
	C738.051453,1110.183105 724.279297,1109.081909 710.512695,1107.973022 
	C706.861694,1107.678955 704.321655,1108.800659 701.842468,1111.585449 
	C682.023499,1133.848389 662.049988,1155.973755 641.674316,1178.163086 
	C641.224792,1178.185059 640.857300,1177.879150 640.857300,1177.879150 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M1785.603271,1629.657715 
	C1748.213135,1649.879028 1711.024780,1649.785767 1673.250488,1630.792480 
	C1674.227173,1629.246948 1674.849854,1628.079468 1675.640381,1627.039551 
	C1682.622559,1617.855103 1681.988159,1619.523438 1676.369141,1610.268433 
	C1670.150757,1600.026489 1663.713257,1589.914795 1657.671875,1579.570801 
	C1656.752441,1577.996460 1656.695801,1575.074829 1657.541748,1573.456665 
	C1661.469238,1565.943848 1665.718872,1558.587646 1670.130493,1551.344116 
	C1672.657837,1547.194580 1673.820801,1543.131592 1673.066895,1538.156372 
	C1671.222900,1525.989136 1669.769165,1513.758545 1668.390747,1501.527344 
	C1668.000854,1498.065918 1666.405518,1496.237915 1663.293335,1494.971802 
	C1650.980591,1489.963013 1638.736694,1484.785034 1626.469849,1479.670898 
	C1638.754639,1448.970337 1677.913696,1417.029297 1724.338135,1415.528198 
	C1777.902710,1413.796021 1824.639038,1448.806641 1838.818481,1498.425903 
	C1853.429321,1549.554810 1832.085815,1601.951782 1785.603271,1629.657715 
z"
      />
      <path
        fill="#95C121"
        opacity="1.000000"
        stroke="none"
        d="
M702.881958,1652.093262 
	C625.402527,1622.699463 556.309448,1580.334106 494.537506,1524.704834 
	C506.207520,1512.167725 517.700439,1499.820923 529.378906,1487.274780 
	C543.971252,1497.307007 557.809814,1507.795776 572.584656,1516.737427 
	C592.082703,1528.537598 607.205505,1544.122437 620.064636,1562.820801 
	C636.191772,1586.271240 653.797913,1608.701538 670.588379,1631.701782 
	C673.311096,1635.431396 676.213867,1636.965088 680.928650,1636.991943 
	C723.403137,1637.234131 765.876404,1637.722534 808.349426,1638.193481 
	C824.997375,1638.378052 841.646606,1638.594482 858.289124,1639.029541 
	C863.091492,1639.155151 865.569031,1637.767212 866.393311,1632.634155 
	C872.458679,1594.861206 878.753113,1557.125000 884.978149,1519.377686 
	C886.624084,1509.396729 888.279663,1499.417236 890.042236,1488.763550 
	C899.545654,1488.763550 908.667664,1488.763550 918.001709,1488.763550 
	C918.001709,1495.791870 918.125916,1503.544067 917.978210,1511.291138 
	C917.543396,1534.096313 917.096802,1556.902100 916.406006,1579.700195 
	C916.290222,1583.520996 917.479065,1585.613281 920.943665,1586.910522 
	C926.359985,1588.938232 931.695557,1591.181763 938.411255,1593.873291 
	C931.666931,1598.038208 926.080017,1602.224243 919.899109,1605.160034 
	C904.579956,1612.436768 889.036316,1619.250488 873.473572,1625.998291 
	C869.688782,1627.639160 868.188904,1630.005249 868.048584,1633.963989 
	C867.830444,1640.115601 867.207703,1646.251709 866.833435,1652.399170 
	C866.461487,1658.508301 867.700256,1659.798950 873.760925,1659.873413 
	C889.915833,1660.071899 906.070496,1660.291260 922.225647,1660.467163 
	C954.202271,1660.815308 986.179016,1661.156982 1018.156128,1661.461182 
	C1025.855835,1661.534424 1026.686279,1660.788452 1025.957031,1653.147461 
	C1024.265015,1635.418701 1022.335938,1617.712769 1020.526672,1599.995117 
	C1020.207764,1596.872192 1020.003845,1593.737793 1019.711365,1590.177612 
	C1023.854675,1589.345215 1027.708984,1588.507568 1031.588501,1587.809326 
	C1035.432129,1587.117310 1037.130737,1585.153564 1037.253052,1581.018188 
	C1038.567505,1536.594238 1040.038452,1492.174927 1041.478271,1447.754761 
	C1042.421753,1418.644775 1043.384399,1389.535400 1045.124390,1360.420410 
	C1045.124390,1368.208130 1045.063721,1375.996338 1045.134766,1383.783325 
	C1045.444702,1417.760742 1045.776001,1451.737793 1046.132080,1485.714844 
	C1046.441162,1515.192749 1046.559082,1544.675537 1047.250000,1574.144775 
	C1047.505615,1585.052002 1045.795044,1586.081787 1058.652832,1586.266357 
	C1062.603271,1586.323120 1066.546509,1586.873901 1070.891357,1587.231201 
	C1067.610474,1596.064941 1064.762573,1604.763306 1061.173096,1613.144165 
	C1056.369507,1624.360107 1054.213379,1635.797363 1054.866211,1648.051758 
	C1055.494629,1659.846802 1055.002197,1659.873047 1066.663086,1659.873047 
	C1089.158936,1659.873047 1111.654907,1659.873047 1134.150757,1659.873047 
	C1135.733398,1659.873047 1137.316040,1659.873047 1138.898804,1659.873047 
	C1138.976440,1660.289917 1139.054077,1660.706665 1139.131714,1661.123535 
	C1124.029541,1665.406860 1109.010498,1670.013916 1093.810425,1673.916260 
	C1034.752075,1689.078979 974.674988,1695.612305 913.764160,1693.753784 
	C841.334839,1691.543945 771.083069,1677.911133 702.881958,1652.093262 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M1478.373901,1567.636719 
	C1495.781494,1574.317139 1512.833618,1580.839111 1530.052979,1587.425049 
	C1525.332397,1605.492065 1520.719604,1623.146606 1515.990234,1641.247070 
	C1506.523682,1639.388306 1497.421143,1637.645020 1488.336914,1635.810669 
	C1394.920288,1616.947754 1301.519531,1598.006348 1208.063843,1579.339722 
	C1201.806519,1578.089844 1197.747314,1575.720337 1194.910889,1569.902588 
	C1191.124756,1562.137207 1186.183228,1554.940552 1182.265381,1547.231567 
	C1180.793335,1544.334961 1179.995972,1540.618530 1180.276489,1537.396362 
	C1181.170410,1527.124878 1182.599731,1516.892578 1184.131958,1506.691772 
	C1184.364014,1505.147339 1185.950928,1503.165649 1187.406128,1502.543335 
	C1205.602051,1494.762329 1223.848999,1487.094849 1242.208008,1479.709351 
	C1244.338013,1478.852539 1247.457031,1479.239502 1249.717651,1480.100220 
	C1304.888062,1501.105591 1360.004395,1522.253174 1415.130005,1543.376343 
	C1436.093262,1551.409180 1457.055542,1559.444214 1478.373901,1567.636719 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M413.653473,1215.570068 
	C425.622040,1202.815308 437.245453,1190.208374 449.149841,1177.872681 
	C451.997650,1174.921631 455.781372,1172.873901 459.585205,1170.079712 
	C478.788910,1181.590942 498.629150,1193.471313 518.456909,1205.372437 
	C540.720581,1218.735474 562.971985,1232.119019 585.231079,1245.489746 
	C590.966614,1248.934937 591.755859,1248.753784 596.153076,1243.853638 
	C632.964783,1202.832153 669.770813,1161.805542 706.721252,1120.909180 
	C708.223938,1119.246094 711.183105,1117.958862 713.404785,1118.043579 
	C724.709045,1118.473633 736.005066,1119.290283 747.273438,1120.309692 
	C748.950745,1120.461426 751.298767,1122.064941 751.921509,1123.578857 
	C756.219666,1134.027954 760.260986,1144.589233 764.050232,1155.233643 
	C764.582764,1156.729492 763.901855,1159.489502 762.754456,1160.628418 
	C739.699341,1183.512207 716.498840,1206.249756 693.316101,1229.005127 
	C672.631348,1249.308594 651.733337,1269.399780 631.314331,1289.966797 
	C618.879517,1302.491943 607.173767,1315.740967 595.277588,1328.517700 
	C579.359009,1319.018555 565.662964,1310.862915 552.001343,1302.649902 
	C551.186890,1302.160400 550.361450,1301.323608 550.026489,1300.460083 
	C547.517090,1293.991699 542.062195,1291.565186 535.990845,1289.704224 
	C516.458069,1283.717163 500.197510,1271.500366 482.849823,1261.400635 
	C459.696747,1247.920898 436.791748,1234.015015 413.783752,1220.286377 
	C412.932220,1219.778198 412.117096,1219.208984 411.137787,1218.572510 
	C411.955292,1217.581909 412.683319,1216.699585 413.653473,1215.570068 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M1471.989014,898.980591 
	C1486.408936,892.421997 1500.500977,886.044495 1514.498657,879.466248 
	C1516.925903,878.325623 1518.513794,878.413269 1520.722290,880.031616 
	C1541.139404,894.994019 1561.644043,909.837341 1582.184082,924.630859 
	C1584.301636,926.156067 1585.243530,927.495117 1584.676147,930.342773 
	C1573.725586,985.304749 1562.868408,1040.285645 1552.138550,1095.291138 
	C1551.545654,1098.330200 1550.278809,1099.506958 1547.427856,1099.947632 
	C1537.238647,1101.522705 1527.096069,1103.425415 1516.879395,1104.777222 
	C1514.579102,1105.081543 1511.462402,1104.370483 1509.716797,1102.924927 
	C1489.702515,1086.351196 1469.838013,1069.594971 1450.086914,1052.708130 
	C1448.460327,1051.317383 1447.215088,1048.679321 1447.035278,1046.517456 
	C1444.317505,1013.841858 1441.804688,981.149109 1439.251221,948.459900 
	C1438.499268,938.835449 1437.893677,929.197327 1436.963745,919.590332 
	C1436.640381,916.248962 1437.658813,914.523804 1440.762329,913.167114 
	C1451.122192,908.638306 1461.350464,903.808350 1471.989014,898.980591 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M390.710907,1133.310791 
	C366.258118,1086.043457 341.979919,1039.106201 317.542297,991.860535 
	C352.840210,964.660889 387.865814,937.671082 423.307159,910.360901 
	C424.363922,912.308960 425.252106,913.827209 426.031097,915.399536 
	C450.903870,965.606567 475.741821,1015.830811 500.690308,1066.000244 
	C502.185120,1069.006226 502.260620,1070.771362 499.355103,1073.042725 
	C467.220978,1098.164185 435.201141,1123.431641 403.145538,1148.653442 
	C402.254913,1149.354126 401.310181,1149.986084 399.879883,1151.019043 
	C396.797974,1145.064453 393.841736,1139.352539 390.710907,1133.310791 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M1024.120117,465.321411 
	C1006.034302,465.902863 988.433228,466.465790 970.323059,467.044983 
	C962.056519,409.910400 953.832947,353.072723 945.531555,295.697021 
	C954.901550,294.099731 963.656311,292.124023 972.520813,291.187927 
	C997.975342,288.499939 1023.457458,286.026978 1048.967407,283.941742 
	C1055.520020,283.406158 1062.234009,284.423370 1068.838989,285.079163 
	C1074.522217,285.643494 1078.677246,288.589722 1079.354004,294.614777 
	C1080.836304,307.807800 1083.194702,321.038940 1083.124512,334.243530 
	C1082.932129,370.496826 1081.722290,406.745758 1080.787598,442.993103 
	C1080.612915,449.772125 1079.846191,456.535828 1079.324951,463.686340 
	C1060.781372,464.234131 1042.693115,464.768494 1024.120117,465.321411 
z"
      />
      <path
        fill="#95C120"
        opacity="1.000000"
        stroke="none"
        d="
M1301.556519,877.463135 
	C1307.185669,844.589966 1312.750732,812.142395 1318.055908,779.652344 
	C1318.455933,777.201294 1317.661011,774.029907 1316.305664,771.905090 
	C1308.970947,760.405884 1301.284790,749.130920 1293.293457,737.138977 
	C1307.364502,727.190186 1321.289795,717.344421 1335.684814,707.166565 
	C1336.908813,708.476379 1338.167236,709.694458 1339.280029,711.033386 
	C1351.836792,726.143555 1364.435425,741.220276 1376.808716,756.479736 
	C1377.992798,757.940063 1378.457642,760.731262 1378.037231,762.635437 
	C1367.321899,811.169312 1356.197021,859.614929 1345.877808,908.231750 
	C1344.437988,915.016052 1346.335938,922.692688 1347.523804,929.817017 
	C1351.324097,952.608032 1355.516968,975.333618 1359.655884,998.633850 
	C1345.642334,1006.368774 1331.601929,1014.118469 1316.629272,1022.382751 
	C1317.612793,1011.371765 1318.484741,1001.342224 1319.411255,991.317810 
	C1320.207642,982.702271 1321.105225,974.096008 1321.878418,965.478516 
	C1322.177856,962.141846 1322.719116,958.370422 1318.035034,957.643005 
	C1313.809814,956.986877 1312.935181,960.299927 1311.942627,963.444824 
	C1306.690430,980.085510 1301.366821,996.703552 1296.052612,1013.324524 
	C1295.457642,1015.185425 1294.766235,1017.015381 1294.061279,1019.026245 
	C1289.975342,1018.210815 1286.258301,1017.468994 1281.764160,1016.572144 
	C1282.582153,1010.824036 1283.319458,1005.139954 1284.209473,999.479919 
	C1287.360840,979.439148 1290.643188,959.418396 1293.634644,939.354126 
	C1293.958008,937.184265 1293.426147,933.835754 1291.992065,932.750977 
	C1290.563354,931.670105 1287.238281,932.133179 1285.197754,932.993713 
	C1277.244751,936.347595 1269.471436,940.127808 1261.068481,944.009521 
	C1257.696777,937.443481 1254.390991,931.006042 1250.866577,924.142578 
	C1263.158813,919.065063 1275.112549,913.638000 1287.431030,909.230225 
	C1294.362793,906.749878 1298.204834,903.238037 1298.600830,895.597168 
	C1298.908691,889.657959 1300.439941,883.782104 1301.556519,877.463135 
z"
      />
      <path
        fill="#95C120"
        opacity="1.000000"
        stroke="none"
        d="
M593.238647,555.222046 
	C597.106201,553.569031 600.619141,552.058472 604.136169,550.557251 
	C607.411072,549.159302 608.517822,546.877258 607.554993,543.341309 
	C605.860474,537.118835 604.395691,530.833801 602.473145,523.125061 
	C604.892761,525.066162 606.254761,526.095886 607.548035,527.205505 
	C646.336670,560.484985 685.157410,593.727234 723.842896,627.126160 
	C727.845398,630.581726 731.348511,631.904785 736.784607,630.354797 
	C748.919922,626.894775 761.312134,624.333496 773.606445,621.435120 
	C774.867371,621.137817 776.174622,621.036804 777.960571,620.770020 
	C783.230652,641.993774 788.451782,663.020508 793.780579,684.480652 
	C779.708801,686.395935 766.395447,688.210449 753.081421,690.019592 
	C734.297852,692.571899 715.507935,695.078857 696.735535,697.710938 
	C693.607117,698.149597 691.228638,698.020447 688.808228,695.320190 
	C650.146484,652.188293 611.357483,609.170410 572.603149,566.121521 
	C572.385681,565.880005 572.248352,565.566284 571.678894,564.653931 
	C578.805786,561.533447 585.845825,558.450989 593.238647,555.222046 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M1603.445312,1575.435547 
	C1582.610352,1577.280884 1562.234863,1579.084351 1541.853271,1580.816162 
	C1540.595947,1580.922974 1539.204590,1580.691406 1538.020386,1580.238525 
	C1505.426025,1567.776001 1472.849243,1555.267334 1440.276245,1542.749390 
	C1438.919800,1542.228149 1437.626709,1541.542725 1435.591675,1540.605591 
	C1453.161743,1533.864990 1470.001831,1527.403320 1486.842773,1520.943726 
	C1522.060425,1507.434692 1557.298584,1493.979248 1592.468506,1480.347534 
	C1596.483887,1478.791382 1599.821899,1478.861206 1603.816162,1480.587769 
	C1620.747192,1487.906006 1637.798462,1494.952759 1654.906860,1501.847656 
	C1657.969116,1503.081665 1659.242432,1504.682007 1659.600952,1507.874023 
	C1660.825684,1518.778076 1662.379761,1529.645264 1663.616089,1540.548218 
	C1663.784790,1542.035522 1663.155029,1543.808350 1662.398315,1545.173584 
	C1658.044067,1553.028076 1653.685669,1560.889526 1648.972168,1568.528687 
	C1647.963867,1570.162598 1645.568237,1571.706055 1643.668701,1571.901855 
	C1630.434692,1573.265381 1617.163086,1574.262817 1603.445312,1575.435547 
z"
      />
      <path
        fill="#95C121"
        opacity="1.000000"
        stroke="none"
        d="
M443.978455,1386.982178 
	C435.253662,1395.631958 426.609192,1404.364502 417.789001,1412.916016 
	C392.201233,1437.724365 366.549683,1462.467285 340.909668,1487.221802 
	C327.851318,1499.829346 314.774536,1512.417847 301.684113,1524.991943 
	C296.783508,1529.699463 296.877045,1531.759155 302.185883,1536.155884 
	C309.471619,1542.189819 316.712738,1548.277466 324.375641,1554.678345 
	C311.228455,1563.927002 298.815033,1573.527588 285.497009,1581.643555 
	C279.312805,1585.412109 271.380859,1586.330688 264.222137,1588.477539 
	C252.451752,1592.007324 240.665817,1595.485229 228.675217,1599.047729 
	C196.635651,1557.584595 164.687042,1516.239380 132.437195,1474.504150 
	C136.654633,1470.940308 140.664444,1467.551758 145.099380,1463.804077 
	C152.102966,1472.575439 158.773071,1481.243408 165.826172,1489.587524 
	C168.214111,1492.412598 171.258560,1495.030884 174.534561,1496.701050 
	C196.766693,1508.036011 219.173874,1519.027466 241.434418,1530.307617 
	C244.770279,1531.998047 247.452209,1532.040039 250.762375,1530.318359 
	C262.714447,1524.101196 274.764069,1518.067139 286.863129,1512.140015 
	C290.811584,1510.205811 291.733398,1507.744995 290.046448,1503.706055 
	C286.270966,1494.666626 282.741364,1485.524292 278.909851,1475.917969 
	C285.809692,1472.155029 292.617157,1468.435425 299.431030,1464.727539 
	C346.337524,1439.203369 393.244354,1413.679810 440.158813,1388.170166 
	C441.172241,1387.619141 442.277466,1387.236938 443.678955,1386.895996 
	C444.018066,1387.015991 443.978455,1386.982178 443.978455,1386.982178 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M1585.000000,1653.000000 
	C1570.050537,1653.000000 1555.600952,1653.000000 1540.950562,1653.000000 
	C1540.950562,1631.928833 1540.950562,1611.372437 1540.950562,1590.529907 
	C1549.461792,1589.735718 1557.702515,1588.905151 1565.954468,1588.208496 
	C1591.814209,1586.025391 1617.673462,1583.830322 1643.550659,1581.875122 
	C1645.346191,1581.739502 1648.076538,1583.023682 1649.035034,1584.509888 
	C1656.154419,1595.549438 1662.935547,1606.807129 1670.081909,1618.417358 
	C1661.762329,1629.496460 1653.469482,1640.691895 1644.918213,1651.686279 
	C1644.084106,1652.758789 1641.657837,1652.938721 1639.967773,1652.946655 
	C1621.812134,1653.032349 1603.656006,1653.000000 1585.000000,1653.000000 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M513.993530,505.960327 
	C512.836609,493.254547 511.689270,481.009583 510.480560,468.110016 
	C520.586731,467.730011 530.307190,467.336456 540.030029,467.012848 
	C543.856873,466.885468 547.688843,466.892670 551.518616,466.878387 
	C555.569885,466.863312 557.998108,465.485168 558.304321,460.851044 
	C559.334900,445.251526 560.659790,429.671509 561.875732,414.084259 
	C561.952698,413.098145 562.060364,412.114441 562.231873,410.304901 
	C568.112976,412.251678 573.743103,414.007324 579.259827,416.066803 
	C580.020935,416.350952 580.627747,418.143341 580.618774,419.231873 
	C580.479736,436.208496 579.449646,453.223450 580.302734,470.144958 
	C580.788330,479.776825 584.192017,489.283844 586.489868,498.796783 
	C589.728394,512.203857 593.072754,525.587280 596.575867,538.927185 
	C597.365601,541.934509 596.813599,543.341003 593.851562,544.580017 
	C580.665039,550.095642 567.622559,555.956604 554.415710,561.421448 
	C552.842346,562.072449 550.079407,561.734131 548.720337,560.716187 
	C538.729492,553.233337 528.909973,545.517883 519.170532,537.708435 
	C517.928589,536.712585 516.916321,534.815186 516.726196,533.224487 
	C515.660889,524.308899 514.880676,515.359192 513.993530,505.960327 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M1240.657471,1621.218140 
	C1240.264648,1619.332886 1239.422852,1617.355835 1240.062012,1616.192505 
	C1243.024170,1610.802734 1246.239380,1605.529541 1249.736938,1600.472534 
	C1250.587402,1599.242798 1253.021362,1598.132202 1254.440186,1598.413574 
	C1292.116943,1605.887695 1329.756104,1613.551514 1367.692383,1621.241821 
	C1367.692383,1631.665405 1367.692383,1642.068237 1367.692383,1653.000122 
	C1366.137451,1653.000122 1364.690552,1653.000244 1363.243774,1653.000244 
	C1331.748657,1653.000244 1300.253174,1652.949097 1268.758667,1653.078247 
	C1265.559326,1653.091431 1263.656250,1652.114502 1261.796143,1649.537720 
	C1254.973633,1640.086792 1247.881470,1630.830688 1240.657471,1621.218140 
z"
      />
      <path
        fill="#95C120"
        opacity="1.000000"
        stroke="none"
        d="
M698.578857,1319.729370 
	C699.436462,1327.180298 700.212036,1334.281738 700.705505,1341.402832 
	C701.266479,1349.496826 701.575256,1357.608276 702.025452,1366.329346 
	C692.652649,1364.718872 683.847290,1363.244019 675.056396,1361.687378 
	C657.201904,1358.525513 639.382935,1355.149658 621.488281,1352.237427 
	C616.311279,1351.394897 612.097168,1349.643433 608.533447,1345.776489 
	C605.399902,1342.376343 601.849487,1339.360474 598.036011,1335.751831 
	C601.527588,1332.413208 604.769714,1329.381714 607.935791,1326.272705 
	C617.327759,1317.050537 626.585327,1307.686768 636.164734,1298.664307 
	C637.786438,1297.136841 640.852661,1296.141968 643.063110,1296.416626 
	C651.970093,1297.523804 660.806396,1299.206299 669.662659,1300.712524 
	C677.004395,1301.961182 678.456482,1300.826538 679.082520,1293.368530 
	C679.247864,1291.398438 679.610962,1289.444702 680.065552,1286.169922 
	C686.566711,1297.966553 692.469482,1308.677612 698.578857,1319.729370 
z"
      />
      <path
        fill="#95C121"
        opacity="1.000000"
        stroke="none"
        d="
M532.220703,1342.632080 
	C535.890991,1360.795898 539.467957,1378.544067 543.148438,1396.805786 
	C540.391174,1397.631226 537.797485,1398.407837 534.792847,1399.307373 
	C530.814270,1386.383789 526.956665,1373.878906 523.117798,1361.368286 
	C521.947083,1357.553101 520.844360,1353.717285 519.679565,1349.900269 
	C518.786560,1346.974121 517.865845,1343.818481 513.948975,1344.150635 
	C509.997131,1344.485718 509.645477,1347.602051 509.472778,1350.774048 
	C508.721863,1364.565674 507.909332,1378.354126 507.119415,1392.143677 
	C507.037201,1393.579590 506.956787,1395.015625 506.837769,1397.118896 
	C499.165894,1392.730103 491.941254,1388.698242 484.859619,1384.429077 
	C483.877106,1383.836914 483.111267,1382.089722 483.070770,1380.850220 
	C482.499878,1363.383667 482.065613,1345.912720 481.630157,1328.442017 
	C481.610046,1327.635132 481.676941,1326.697144 482.063538,1326.028564 
	C486.394958,1318.539429 490.564728,1310.937378 495.334564,1303.734009 
	C496.615540,1301.799561 499.874023,1301.255615 502.066254,1299.829712 
	C512.228394,1293.220459 522.309814,1292.803955 533.178772,1298.658936 
	C537.140564,1300.793213 540.336487,1302.746460 542.599915,1306.745239 
	C549.647705,1319.196777 556.776245,1331.618530 564.404236,1343.717163 
	C567.208374,1348.164917 567.248230,1351.024536 562.788269,1353.783569 
	C561.964844,1354.292847 561.269958,1355.010010 560.318298,1355.794067 
	C553.460510,1346.828857 546.645569,1338.011475 539.947571,1329.106079 
	C538.010254,1326.530396 536.046631,1324.320923 532.542908,1326.009766 
	C529.212891,1327.614990 529.853027,1330.559082 530.422485,1333.403198 
	C531.010010,1336.337036 531.560608,1339.278320 532.220703,1342.632080 
z"
      />
      <path
        fill="#95C120"
        opacity="1.000000"
        stroke="none"
        d="
M1034.034180,553.030579 
	C1023.093689,550.678284 1012.575256,548.386230 1001.564819,545.986938 
	C1003.676819,522.290955 1005.753052,498.996155 1007.903076,474.873138 
	C1023.373413,474.873138 1038.436768,474.873138 1054.057251,474.873138 
	C1055.664795,488.461060 1057.337891,502.612823 1059.013916,516.764221 
	C1059.952515,524.688965 1060.760132,532.632751 1061.901611,540.528259 
	C1062.382446,543.853455 1061.614502,545.778015 1058.301514,546.961914 
	C1054.241699,548.412598 1050.195557,550.057251 1046.432373,552.140076 
	C1042.453247,554.342407 1038.584351,554.493347 1034.034180,553.030579 
z"
      />
      <path
        fill="#95C121"
        opacity="1.000000"
        stroke="none"
        d="
M1170.376953,1573.005127 
	C1170.756958,1565.149536 1171.078491,1557.742676 1171.399902,1550.335815 
	C1171.786865,1550.218750 1172.173950,1550.101685 1172.560913,1549.984619 
	C1174.569702,1553.472656 1176.583496,1556.957642 1178.586060,1560.449219 
	C1182.723999,1567.664429 1186.618896,1575.036743 1191.129883,1582.010376 
	C1192.548950,1584.204102 1195.414673,1586.226562 1197.961792,1586.799072 
	C1212.039062,1589.963867 1226.222534,1592.656494 1240.472412,1595.531616 
	C1237.863525,1605.206543 1227.557739,1611.341675 1228.466919,1623.732056 
	C1212.705322,1630.954224 1196.047607,1638.587158 1178.768799,1646.504639 
	C1178.618408,1644.541626 1178.367554,1643.573730 1178.501343,1642.662231 
	C1180.049194,1632.109741 1176.166992,1623.364380 1170.349487,1614.801270 
	C1163.541992,1604.780518 1157.611206,1594.164062 1150.890259,1583.133789 
	C1155.379395,1582.479370 1159.349121,1581.530884 1163.344360,1581.408447 
	C1168.827759,1581.239868 1170.705811,1578.482178 1170.376953,1573.005127 
z"
      />
      <path
        fill="#95C121"
        opacity="1.000000"
        stroke="none"
        d="
M1639.512451,1362.522461 
	C1656.625488,1358.200684 1673.357788,1354.017334 1690.685425,1349.685059 
	C1694.160645,1369.415527 1697.574951,1388.800659 1701.089233,1408.753296 
	C1684.377930,1412.979370 1668.829834,1419.739136 1654.415161,1430.461426 
	C1651.869141,1421.420166 1649.449341,1412.902466 1647.073364,1404.372314 
	C1643.599365,1391.900024 1640.268799,1379.385864 1636.616699,1366.966187 
	C1635.776733,1364.110107 1636.242310,1362.907104 1639.512451,1362.522461 
z"
      />
      <path
        fill="#96C222"
        opacity="1.000000"
        stroke="none"
        d="
M359.729065,1095.181641 
	C370.706451,1115.851196 381.386047,1136.319458 391.996063,1156.823853 
	C396.139038,1164.830322 397.802246,1165.209229 405.025024,1159.480591 
	C411.407990,1154.418091 417.821350,1149.393921 424.777649,1143.914551 
	C431.584503,1151.711914 438.298706,1159.403198 445.439850,1167.583496 
	C427.433380,1175.157349 409.929749,1182.519897 392.024048,1190.051514 
	C390.362427,1187.197021 388.853943,1184.665771 387.403198,1182.101807 
	C383.556396,1175.302856 380.226715,1168.150513 375.810394,1161.746094 
	C362.639465,1142.646240 358.663513,1120.258789 352.151398,1098.322266 
	C354.645416,1097.178101 357.024414,1096.086548 359.729065,1095.181641 
z"
      />
      <path
        fill="#95C121"
        opacity="1.000000"
        stroke="none"
        d="
M697.716431,1429.287231 
	C674.276306,1407.310669 651.087708,1385.585449 626.797729,1362.828369 
	C652.867371,1367.428467 677.555176,1371.784790 702.658447,1376.214478 
	C703.840820,1396.074585 705.014771,1415.793213 706.282471,1437.087646 
	C702.877869,1433.996338 700.422913,1431.767456 697.716431,1429.287231 
z"
      />
      <path
        fill="#97C225"
        opacity="1.000000"
        stroke="none"
        d="
M450.803589,1123.806152 
	C466.010986,1111.673096 481.213409,1099.533936 496.428925,1087.411133 
	C500.594727,1084.092163 504.818268,1080.845825 508.981476,1077.523804 
	C514.245300,1073.323364 514.484192,1072.226318 511.496368,1066.212769 
	C498.772736,1040.604614 486.027130,1015.007202 473.313904,989.393860 
	C467.715668,978.115051 462.175476,966.807434 456.626373,955.548279 
	C463.468140,951.500427 463.831085,951.676941 467.082123,958.359802 
	C486.786987,998.865540 506.534515,1039.350464 526.261353,1079.845581 
	C527.046082,1081.456543 527.765503,1083.099243 528.775085,1085.291016 
	C503.016785,1098.403442 477.586151,1111.348999 451.651611,1124.221924 
	C451.147736,1124.149170 450.803619,1123.806152 450.803589,1123.806152 
z"
      />
      <path
        fill="#95C121"
        opacity="1.000000"
        stroke="none"
        d="
M1769.510742,1647.516113 
	C1783.690308,1642.584717 1796.107056,1635.330566 1807.546753,1626.249756 
	C1808.945801,1625.139038 1811.405273,1624.550537 1813.180176,1624.853027 
	C1830.856567,1627.865112 1848.492188,1631.115723 1866.651978,1634.391357 
	C1865.648438,1639.164673 1864.864624,1643.698975 1863.629883,1648.106934 
	C1863.374146,1649.019897 1861.445801,1650.037231 1860.285400,1650.041016 
	C1828.312744,1650.145386 1796.339478,1650.124512 1764.152466,1649.425659 
	C1765.823853,1648.845581 1767.495361,1648.265381 1769.510742,1647.516113 
z"
      />
      <path
        fill="#97C225"
        opacity="1.000000"
        stroke="none"
        d="
M550.720581,1469.333252 
	C560.665344,1482.804321 570.401062,1495.990479 580.136780,1509.176514 
	C579.903687,1509.452148 579.670593,1509.727783 579.437439,1510.003540 
	C565.222046,1500.244995 551.006653,1490.486572 536.079651,1480.239624 
	C540.279968,1475.653320 544.234070,1471.335815 548.390442,1466.797485 
	C549.226868,1467.685181 549.869202,1468.366699 550.720581,1469.333252 
z"
      />
      <path
        fill="#97C225"
        opacity="1.000000"
        stroke="none"
        d="
M651.918213,1282.925049 
	C657.394470,1277.144653 662.619812,1271.614868 668.533203,1265.356812 
	C674.223511,1274.522339 669.217468,1282.539917 670.180176,1290.987671 
	C662.573914,1289.792725 655.649109,1288.704834 647.718201,1287.458984 
	C649.374817,1285.662231 650.521057,1284.418945 651.918213,1282.925049 
z"
      />
      <path
        fill="#97C225"
        opacity="1.000000"
        stroke="none"
        d="
M1394.161133,1627.929688 
	C1388.658569,1629.015869 1383.490601,1630.055176 1377.857666,1631.187866 
	C1377.857666,1628.432251 1377.857666,1626.076172 1377.857666,1623.113281 
	C1383.747070,1624.438599 1389.495850,1625.730347 1395.241211,1627.037354 
	C1395.368530,1627.066406 1395.457397,1627.265137 1395.564209,1627.385010 
	C1395.208130,1627.550903 1394.852051,1627.716797 1394.161133,1627.929688 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M641.402100,1178.345459 
	C641.220520,1178.964233 640.861633,1179.422729 639.816040,1180.758667 
	C640.129211,1179.206665 640.230530,1178.704590 640.594604,1178.040894 
	C640.857300,1177.879150 641.224792,1178.185059 641.402100,1178.345459 
z"
      />
      <path
        fill="#97C225"
        opacity="1.000000"
        stroke="none"
        d="
M449.971619,1124.969482 
	C449.636292,1125.238281 449.307983,1125.517090 448.956085,1125.762085 
	C448.915741,1125.790161 448.743317,1125.628418 448.632202,1125.554565 
	C448.933807,1125.308960 449.235443,1125.063232 449.776886,1124.914795 
	C450.016724,1125.011963 449.971619,1124.969482 449.971619,1124.969482 
z"
      />
      <path
        fill="#95C121"
        opacity="1.000000"
        stroke="none"
        d="
M444.038605,1387.031982 
	C444.067535,1386.807129 444.057617,1386.562744 444.101074,1386.328369 
	C444.108917,1386.286133 444.335663,1386.284302 444.461334,1386.263916 
	C444.481384,1386.473389 444.501434,1386.682983 444.250000,1386.937256 
	C443.978455,1386.982178 444.018066,1387.015991 444.038605,1387.031982 
z"
      />
      <path
        fill="#97C225"
        opacity="1.000000"
        stroke="none"
        d="
M450.041504,1125.030518 
	C450.115356,1124.706055 450.164398,1124.363159 450.508545,1123.913086 
	C450.803619,1123.806152 451.147736,1124.149170 451.313782,1124.330444 
	C451.161499,1124.690186 450.843140,1124.868774 450.248199,1125.008301 
	C449.971619,1124.969482 450.016724,1125.011963 450.041504,1125.030518 
z"
      />
      <path
        fill="#FCFDFA"
        opacity="1.000000"
        stroke="none"
        d="
M679.130127,845.880310 
	C706.348328,868.921265 733.298340,891.728333 760.227600,914.559753 
	C762.061035,916.114136 763.527161,917.270752 766.120239,915.405334 
	C767.261108,914.584656 769.666626,915.209229 771.409790,915.585754 
	C795.134583,920.710815 818.831360,925.965820 842.569519,931.027344 
	C846.374329,931.838623 848.145447,933.779053 849.016724,937.500793 
	C855.912781,966.958191 862.254028,996.574341 870.271729,1025.727539 
	C873.976868,1039.199707 880.903503,1051.809692 886.625610,1064.697021 
	C892.765991,1078.526489 899.322266,1092.172241 905.391968,1106.031616 
	C906.295410,1108.094360 906.476746,1111.762573 905.255066,1113.093628 
	C904.099487,1114.352661 900.241455,1114.393677 898.283691,1113.466919 
	C861.463501,1096.035522 824.725098,1078.429932 788.081116,1060.631104 
	C786.146057,1059.691284 784.179565,1056.828003 783.947815,1054.674927 
	C781.436523,1031.350952 779.046021,1008.008606 777.085144,984.632446 
	C775.696411,968.076721 773.735291,951.721436 766.903931,935.366089 
	C762.190674,944.797913 757.765137,953.641052 753.350891,962.489868 
	C738.572693,992.114258 723.867249,1021.775696 708.875366,1051.291504 
	C707.824829,1053.359863 704.785461,1055.437378 702.470703,1055.692505 
	C663.275635,1060.011475 624.049500,1064.048828 584.828308,1068.129395 
	C578.715820,1068.765259 577.632507,1067.978027 576.206482,1062.021729 
	C568.156128,1028.397095 560.127014,994.767517 552.070068,961.144592 
	C546.879578,939.483765 541.657837,917.830383 536.441711,896.175781 
	C534.684326,888.880127 535.079041,888.028625 541.909607,885.340210 
	C581.819702,869.631714 621.750061,853.974243 661.626099,838.179871 
	C665.640930,836.589661 668.872925,836.542114 672.026672,839.812195 
	C674.096558,841.958374 676.566345,843.718933 679.130127,845.880310 
M588.142151,877.615601 
	C574.094543,883.122803 560.046936,888.630066 545.928406,894.165039 
	C559.106445,949.103394 572.164246,1003.540466 585.339722,1058.468018 
	C596.095825,1057.319580 606.481934,1056.189087 616.872925,1055.105225 
	C643.523315,1052.324951 670.183716,1049.635986 696.811584,1046.655640 
	C698.808716,1046.432129 701.423035,1044.613037 702.330322,1042.817993 
	C718.843567,1010.145752 735.139038,977.363525 751.480835,944.604614 
	C754.357971,938.837280 757.234924,933.069885 760.137024,927.252319 
	C759.012146,926.231689 758.180054,925.429321 757.299377,924.684448 
	C728.045837,899.944824 698.735413,875.271790 669.604492,850.388611 
	C666.407043,847.657349 663.923462,847.624878 660.293640,849.077515 
	C636.519958,858.591309 612.660950,867.891602 588.142151,877.615601 
M785.091431,928.395630 
	C781.892151,927.737366 778.692871,927.079041 774.937378,926.306274 
	C775.540894,928.582520 775.980286,930.296143 776.449829,932.001343 
	C779.004822,941.280029 782.779846,950.412720 783.902405,959.860779 
	C787.432983,989.576538 789.922791,1019.415344 793.006958,1049.186646 
	C793.180481,1050.861572 794.713440,1053.097656 796.218079,1053.828857 
	C826.261841,1068.430176 856.392944,1082.851929 886.515381,1097.291016 
	C887.893433,1097.951660 889.356750,1098.434448 891.689331,1099.361084 
	C890.602295,1096.823975 889.992798,1095.314453 889.316223,1093.835693 
	C882.403198,1078.725220 875.366150,1063.670044 868.611633,1048.489014 
	C865.722290,1041.995239 862.689026,1035.424561 860.971741,1028.575073 
	C854.022949,1000.858948 847.503662,973.034180 840.991333,945.210754 
	C840.175964,941.726868 838.773193,939.980408 835.101440,939.232422 
	C818.660706,935.882751 802.285156,932.212402 785.091431,928.395630 
z"
      />
      <path
        fill="#94C120"
        opacity="1.000000"
        stroke="none"
        d="
M588.486023,877.438599 
	C612.660950,867.891602 636.519958,858.591309 660.293640,849.077515 
	C663.923462,847.624878 666.407043,847.657349 669.604492,850.388611 
	C698.735413,875.271790 728.045837,899.944824 757.299377,924.684448 
	C758.180054,925.429321 759.012146,926.231689 760.137024,927.252319 
	C757.234924,933.069885 754.357971,938.837280 751.480835,944.604614 
	C735.139038,977.363525 718.843567,1010.145752 702.330322,1042.817993 
	C701.423035,1044.613037 698.808716,1046.432129 696.811584,1046.655640 
	C670.183716,1049.635986 643.523315,1052.324951 616.872925,1055.105225 
	C606.481934,1056.189087 596.095825,1057.319580 585.339722,1058.468018 
	C572.164246,1003.540466 559.106445,949.103394 545.928406,894.165039 
	C560.046936,888.630066 574.094543,883.122803 588.486023,877.438599 
z"
      />
      <path
        fill="#95C120"
        opacity="1.000000"
        stroke="none"
        d="
M785.488770,928.526733 
	C802.285156,932.212402 818.660706,935.882751 835.101440,939.232422 
	C838.773193,939.980408 840.175964,941.726868 840.991333,945.210754 
	C847.503662,973.034180 854.022949,1000.858948 860.971741,1028.575073 
	C862.689026,1035.424561 865.722290,1041.995239 868.611633,1048.489014 
	C875.366150,1063.670044 882.403198,1078.725220 889.316223,1093.835693 
	C889.992798,1095.314453 890.602295,1096.823975 891.689331,1099.361084 
	C889.356750,1098.434448 887.893433,1097.951660 886.515381,1097.291016 
	C856.392944,1082.851929 826.261841,1068.430176 796.218079,1053.828857 
	C794.713440,1053.097656 793.180481,1050.861572 793.006958,1049.186646 
	C789.922791,1019.415344 787.432983,989.576538 783.902405,959.860779 
	C782.779846,950.412720 779.004822,941.280029 776.449829,932.001343 
	C775.980286,930.296143 775.540894,928.582520 774.937378,926.306274 
	C778.692871,927.079041 781.892151,927.737366 785.488770,928.526733 
z"
      />
    </svg>
  );
};

IndividualsAndGroupsIllustration.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  fill: PropTypes.string,
};

IndividualsAndGroupsIllustration.defaultProps = {
  width: 292,
  height: 292,
  fill: "none",
  style: {},
};

export default IndividualsAndGroupsIllustration;
